/* eslint-disable max-len */
import { TitleCasePipe } from '@angular/common';
import { Injectable, signal } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router, UrlSerializer } from '@angular/router';
import { HotToastService } from '@ngneat/hot-toast';
import { ZuperDialogService } from '@zuper/components/zuper-dialog/zuper-dialog.service';
import { TabsData } from 'app/components/multi-module-picker/multi-module-picker.interface';
import { MultiModulePickerService } from 'app/components/multi-module-picker/multi-module-picker.service';
import { NewTimeOffComponent } from 'app/components/new-timeoff/new-timeoff.component';
import { ModuleUidKey, ParamKey } from 'app/components/notes/notes.interface';
import { DateFormatPipe } from 'app/core/pipes/dateFormat.pipe';
import { TimeFormatPipe } from 'app/core/pipes/timeFormat.pipe';
import { AnalyticsService } from 'app/core/services/analytics/analytics.service';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import { NotesService } from 'app/core/services/notes/notes.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { MapPanData } from 'app/modules/maps/map.interface';
import { MapsService } from 'app/modules/maps/maps.service';
import dayjs, { Dayjs } from 'dayjs';
import _, { filter } from 'lodash';
import moment, { Moment } from 'moment';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { catchError, debounceTime, finalize, map, share, switchMap, takeUntil } from 'rxjs/operators';
import * as L from 'leaflet';
import { SharedService } from '../../core/services/shared.service';
import { ModuleAccess, Permissions } from './dispatch-board.interface';

@Injectable({
  providedIn: 'root'
})
export class DispatchBoardService {
  refreshGridCards: boolean = true;
  public get baseUrl(): string {
    return `${this._dataCollectorService.baseurl()}`;
  };
  get timezoneUrl(): any{
    return `${this.baseUrl}/misc/timezone`;
  }
  get quickFilterUrl(): any{
    return `${this.baseUrl}/misc/quick_filters`;
  }
  get metaDataUrl(): any{
    return `${this.baseUrl}/meta_data`;
  }
  get schedulerDataUrl(): any{
    return `${this.baseUrl}/jobs/employee/schedule/filter`;
  }
  get nonJobEventDataUrl(): any{
    return `${this.baseUrl}/non_job_events`;
  }
  get jobCalendarDataUrl(): any{
    return `${this.baseUrl}/jobs/schedule`;
  }
  get teamDataUrl(): any{
    return `${this.baseUrl}/teams/summary`;
  }
  get territoryDataUrl(): any{
    return `${this.baseUrl}/territory`;
  }
  get holidayUrl(): any{
    return `${this.baseUrl}/company/holidays`;
  }
  get gridDataUrl(): any{
    return `${this.baseUrl}/jobs/dispatch_board/filter`;
  }
  get employeeLocationDataUrl(): any{
    return `${this.baseUrl}/location/users`;
  }
  get routesCountUrl(): any{
    return `${this.baseUrl}/routes/count`;
  }
  get routesDataUrl(): any{
    return `${this.baseUrl}/routes`;
  }
  get recurringRoutesDataUrl(): any{
    return `${this.baseUrl}/routes/recurring`;
  }
  get routesFilterDataUrl(): any{
    return `${this.baseUrl}/routes/filter`;
  }
  get scheduleOverlapUrl(): any{
    return `${this.baseUrl}/jobs/schedule/overlap`;
  }
  get timeoffDetailsUrl(): any{
    return `${this.baseUrl}/timesheets/request/timeoff`;
  }
  get jobDetailsUrl(): any{
    return `${this.baseUrl}/jobs`;
  }
  get userAvailabilityUrl(): any{
    return `${this.baseUrl}/users/availability`;
  }
  jobPreview = new Subject<any>();
  routesJobPreview = new Subject<any>();
  gridRecords;
  routeTabGridRecord: any;
  routeTabRoutesRecord: any;
  routeRecords!: any;
  schedulerRecords: any;
  calendarRecords: any;
  jobTabemployeeRecords: any;
  routesTabemployeeRecords: any;
  schedulerRoutesRecords: any;
  tableProxyRecords: any;
  jobRouteTransferEmitter: BehaviorSubject<any> = new BehaviorSubject<any>({});
  /* eslint-disable @typescript-eslint/naming-convention */
  mapLayersRef = { 'jobs': 'JOB', 'users': 'USER', 'organizations': 'ORGANIZATION', 'properties': 'PROPERTY', 'customers': 'CUSTOMER', 'service_territories': '', 'assets': 'ASSETS' };
  lastMapPanData: any;
  jobLocationMapData = { JOBS: { gridJob: null, schedulerJob: null, nearByJob: null }, ROUTES: { gridJob: null, schedulerJob: null, nearByJob: null } };
  routeLocationMapData = { gridRoute: null, schedulerRoute: null };
  filterMeta = { grid: [], grid_route: [], employee: [], scheduler: [], scheduler_route: [], map: [] };
  employeeLocationData = {JOBS: [], ROUTES: []};
  drawOnMapData = { JOBS: [], ROUTES: [] };
  selectedTimezone = { JOBS: null, ROUTES: null };
  selectedTeam = { JOBS: null, ROUTES: null };
  showFindLiveTechInJobMapPopup = { JOBS: true, ROUTES: false };
  isSchedulerHolidayMounted = { JOBS: false, ROUTES: false };
  currentNearbyRequest$: Observable<any> | null = null;
  /* eslint-enable @typescript-eslint/naming-convention */
  customTimezone: string = moment.tz.guess();
  //Reschule model
  eventType: 'job' | 'route' | 'nonJobEvent';
  eventDetails: any;
  eventAssignedTo: any;
  userDetails: any;
  startDateTime: Moment;
  endDateTime: Moment;
  warningTimezone: string;
  holidays: any;
  customUserDetails: any;
  timeFormat: any;
  dateFormat: any;
  userPreferredTimezone: any;
  dateTimeFormat: any;
  holidayObj = {};
  holidayName: any;
  holidayDate: any;
  timeOffUsers: any;
  jobOverlapUsers: any;
  nonJobOverlapUsers: any;
  shiftHoursExceedUsers: any[] = [];
  dueDate: any;
  timeWarnings = { show: false, msg: '' };
  dateWarnings = { show: false, msg: '' };
  dueDateWarning = { show: false, msg: '' };
  eventOverlapWarning = { show: false, msg: '' };
  nonJobEventOverlapWarning = { show: false, msg: '' };
  shiftHoursExceedWarning = { show: false, msg: '' };
  routeDurationExceedWarning = { show: false, msg: '' };
  routeJobScheduleConflictWarning = { show: false, msg: '' };
  warnings = { holiday: false, dueDate: false, businessHours: false, workHours: false, timeoff: false, nonJobEventOverlap: false, overlap: false, shiftHours: false, routeDuration: false, routeJobScheduleConflict: false };
  permissions: Permissions;
  moduleAccess: ModuleAccess;
  companyConfig = { multipleTimezone: false, orgConfigJobTimeoffAlert: false, serviceTerritory: false, businessHours: { start: null, end: null } };
  defaultJobAttributes: any;
  defaultEmployeeAttributes: any;
  defaultRouteAttributes: any;
  userPreferences: any = null;
  previewRouteDetails = signal({ show: false, routeDetailsUid: '', source: '' });

  // eslint-disable-next-line @typescript-eslint/naming-convention
  modeOfTransportIcons = { 'CAR': 'car-side', 'TRUCK': 'truck', 'BIKE': 'person-biking', 'WALK': 'person-walking', 'PEDESTRIAN': 'person-walking' };
  serviceTerritories: any[] = [];
  timezones: Observable<any[]>;
  cancelNearByDataRequest$: Subject<void> = new Subject<void>();
  allTimezoneDetails: any[] = [];
  currentTab: 'JOBS' | 'ROUTES' | 'PLANNING' | 'MAP' = 'JOBS';
  activeDispatchTab: 'JOBS' | 'ROUTES' = 'JOBS';
  activeRouteTab: 'TRACKING' | 'PLANNING' = 'TRACKING';
  jobTypeOptions = [
    {
      label: 'text.all.jobs',
      value: 'ALL'
    },
    {
      label: 'text.unscheduled.jobs',
      value: 'UNSCHEDULED'
    },
    {
      label: 'datapicker.job_assigned.assigned_text',
      value: 'ASSIGNED'
    },
    {
      label: 'text.unassigned_jobs',
      value: 'UNASSIGNED'
    },
    {
      label: 'dispatchBoard.grid.tbar.job_type.overdue',
      value: 'OVERDUE'
    }
  ];
  routeTypeOptions = [
    {
      label: 'dispatchBoard.routes.tbar.route_type.unassigned',
      value: 'UNASSIGNED',
      canShow: true
    },
    {
      label: 'dispatchBoard.routes.tbar.route_type.all_routes',
      value: '',
      canShow: true
    },
    {
      label: 'dispatchBoard.routes.tbar.route_type.recurring_routes',
      value: 'RECURRING_ROUTES',
      canShow: false
    }
  ];
  schedulerViewOptions = [
    {
      label: 'text.day',
      value: 'DAY'
    },
    {
      label: 'calendar.home.tab.week',
      value: 'WEEK'
    },
    {
      label: 'calendar.home.tab.month',
      value: 'MONTH'
    }
  ];
  //Default config
  enableMapViewByDefault: boolean = true;
  enableMapLayerByDefault = { jobs: true, routes: true, routesJob: true, serviceTerritory: true };
  tableViewAttributeMaxCount: number = 10;

  //Shift details
  nonWorkingStartTime: Dayjs;
  nonWorkingEndTime: Dayjs;
  nonWorkingHours: any[] = [];

  //Recurring route details
  recurringRouteDetails = { routeSeriesSegment: { isOpened: false } };
  toggleRecurringRouteViewRouteSeriesSubject: Subject<any> = new Subject<any>();
  recurringRouteDetailsSubject: Subject<any> = new Subject<any>();

  constructor(private _dataCollectorService: DataCollectorService,
    private dateFormatPipe: DateFormatPipe,
    private timeFormatPipe: TimeFormatPipe,
    private _utilityService: UtilityService,
    private _localStorageService: LocalStorageService,
    private _toastService: HotToastService,
    private _zuperDialogService: ZuperDialogService,
    private _multiModulePickerService: MultiModulePickerService,
    private _notesService: NotesService,
    private titlecasePipe: TitleCasePipe,
    private _mapService: MapsService,
    private router: Router,
    private serializer: UrlSerializer,
    private analyticsService: AnalyticsService,
    private sharedService: SharedService,
  ) {
    this.timeFormat = this._utilityService.timeFormat;
    this.dateFormat = this._utilityService.dateFormat;
    this.dateTimeFormat = this._utilityService.dateTimeFormat;
    this.userPreferredTimezone = this._utilityService.preferredTimeZone;
    this.companyConfig =
    {
      orgConfigJobTimeoffAlert: this._utilityService.companyConfig.jobs?.alert_conflict_on_assignment ?? true,
      multipleTimezone: this._utilityService.companyConfig?.general?.allow_switching_timezones ?? false,
      serviceTerritory: this._utilityService.companyConfig?.service_territory?.is_enabled ?? true,
      businessHours: { start: this._utilityService.companyConfig?.business_hours?.start_time || '00:00:00', end: this._utilityService.companyConfig?.business_hours?.end_time || '24:00:00' }
    };
    this.enableMapLayerByDefault.serviceTerritory = this.companyConfig.serviceTerritory ?? false;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    this.selectedTimezone = { 'JOBS': this.userPreferredTimezone, 'ROUTES': this.userPreferredTimezone };
    this.permissions = { newJob: this._utilityService.hasPermission('job.new'), updateJob: this._utilityService.hasPermission('job.update'), scheduleJob: this._utilityService.hasPermission('job.schedule'), rescheduleJob: this._utilityService.hasPermission('job.reschedule'), deleteJob: this._utilityService.hasPermission('job.delete'), updateJobAssignment: this._utilityService.hasPermission('job.update_assignment'), newNote: this._utilityService.hasPermission('job.new_note'), cloneJob: this._utilityService.hasPermission('job.clone'), timesheetTimeoff: this._utilityService.hasPermission('timesheet.new_timeoff'), accessMap: this._utilityService.hasPermission('maps.access'), createRoute: this._utilityService.hasPermission('route.new'), updateRoute: this._utilityService.hasPermission('route.update'), updateRouteAssignment: this._utilityService.hasPermission('route.update_assignment'), addJobToRoute: this._utilityService.hasPermission('route.add_job'), cloneRoute: this._utilityService.hasPermission('text.clone_route'), deleteRoute: this._utilityService.hasPermission('route.delete') };
    this.moduleAccess = { map: this._utilityService.hasModuleAccess('MAPS') && this._utilityService.hasPermission('maps.access'), project: this._utilityService.hasModuleAccess('PROJECT') };
    if (!this.userPreferences) {
      this.userPreferences = this._localStorageService.getLocalStorage('user_preferences');
    }
  }

  setGridRecords(record: any): void {
    this.gridRecords = record;
  }

  getGridRecords(): any {
    return this.gridRecords;
  }

  setRouteTabGridRecords(record: any): void {
    this.routeTabGridRecord = record;
  }

  getRouteTabGridRecords(): any {
    return this.routeTabGridRecord;
  }

  setRouteTabRoutesRecord(record: any): void {
    this.routeTabRoutesRecord = record;
  }

  getRouteTabRoutesRecord(): any {
    return this.routeTabRoutesRecord;
  }


  getRouteRecords(): any {
    return this.routeRecords;
  }

  setRouteRecords(record: any): void {
    this.routeRecords = record;
  }

  setSchedulerRecords(record: any): void {
    this.schedulerRecords = record;
  }

  setCalendarRecords(record: any): void {
    this.calendarRecords = record;
  }

  getCalendarRecords(): void {
    return this.calendarRecords;
  }

  getSchedulerRecords(): any {
    return this.schedulerRecords;
  }

  setSchedulerRoutesRecords(record: any): void {
    this.schedulerRoutesRecords = record;
  }

  getSchedulerRoutesRecords(): any {
    return this.schedulerRoutesRecords;
  }

  setJobTabEmployeeRecords(record: any): void {
    this.jobTabemployeeRecords = record;
  }

  getJobTabEmployeeRecords(): any {
    return this.jobTabemployeeRecords;
  }

  setRouteTabEmployeeRecords(record: any): void {
    this.routesTabemployeeRecords = record;
  }

  getRouteTabEmployeeRecords(): any {
    return this.routesTabemployeeRecords;
  }

  setTableProxyRecords(tableProxyRecords: any): void {
    this.tableProxyRecords = tableProxyRecords;
  }

  getTableProxyRecords(): any {
    return this.tableProxyRecords;
  }

  formatEventDetails(customSelectedAttributes: any, eventDetails: any, additionalParams: any = {}): any {
    if (!customSelectedAttributes || !eventDetails) { return; }
    const customData = {};
    if (Array.isArray(customSelectedAttributes)) {
      customSelectedAttributes = { 1: [...customSelectedAttributes] };
    }
    customData['id'] = eventDetails?.job_uid || eventDetails?.route_uid;
    customData['is_recurrence'] = eventDetails?.is_recurrence;
    customData['routeDetails'] = { isRouteJob: eventDetails?.route?.route_uid ? true : false, routeName: eventDetails?.route?.route_name || '' };
    customData['delayed_job'] = eventDetails?.delayed_job;
    customData['detailsType'] = eventDetails?.detailsType || 'job';
    customData['isJobHasGeoCords'] = this.isJobHasGeoCords(eventDetails);
    customData['customer_address'] = eventDetails?.customer_address;
    customData['current_job_status'] = eventDetails?.current_job_status;
    Object.keys(customSelectedAttributes).map(key => Number(key)).forEach((rowNumber: any) => {
      customSelectedAttributes[rowNumber].forEach((attribute: any) => {
        if (attribute?.isDefaultField) {
          if (attribute.group_uid === 'current_work_order_status') {
            const statusColor = _.get(eventDetails, attribute.status_color_selector);
            customData[attribute.key] = _.get(eventDetails, attribute.selector);
            customData['status_color_selector'] = statusColor ? statusColor : '#02B875';
          }
          else if (attribute.group_uid === 'work_order_actual_date' || attribute.group_uid === 'work_order_scheduled_date') {
            const selectors = attribute.selector;
            const startDateTime = _.get(eventDetails, selectors[0]);
            const endDateTime = _.get(eventDetails, selectors[1]);
            let formatedStartDateTime: any;
            let formatedEndDateTime: any;
            if (startDateTime && !endDateTime) {
              formatedStartDateTime = dayjs(startDateTime).utc().tz(this.selectedTimezone[this.activeDispatchTab]).format(this.dateTimeFormat);;
            }
            else if (startDateTime && endDateTime) {
              let showOnlyScheduledTime: boolean = false;
              let showScheduledEndDate: boolean = false;
             if(additionalParams?.showOnlyScheduledTime){
              if((additionalParams?.currentView === 'WEEK' || additionalParams?.currentView === 'MONTH')  && additionalParams?.schedulerZoomLevel === 0) {
                showOnlyScheduledTime = true;
                showScheduledEndDate = false;
              }
              else {
                showOnlyScheduledTime = true;
                showScheduledEndDate = true;
              }
             }
              [formatedStartDateTime, formatedEndDateTime] = this.getStartEndTime(startDateTime, endDateTime, true, null, showOnlyScheduledTime, showScheduledEndDate);
            }
            if (startDateTime) {
              customData[attribute.key] = {};
              customData[attribute.key]['startDateTime'] = formatedStartDateTime;
              if (endDateTime) {
                customData[attribute.key]['endDateTime'] = formatedEndDateTime;
              }
            }
          }
          else if (attribute.group_uid === 'work_order_created_date' || attribute.group_uid === 'created_date') {
            const dateTime = _.get(eventDetails, attribute.selector);
            if (dateTime) {
              customData[attribute.key] = dayjs.utc(dateTime).tz(this.selectedTimezone[this.activeDispatchTab]).format(this.dateTimeFormat);
            }
          }
          else if (attribute.group_uid === 'work_order_due_date') {
            const dateTime = _.get(eventDetails, attribute.selector);
            if (dateTime) {
              customData[attribute.key] = dayjs.utc(dateTime).tz(this.selectedTimezone[this.activeDispatchTab]).format(this.dateFormat);
            }
          }
          else if (attribute.group_uid === 'job_project') {
            const projectDetails = _.get(eventDetails, attribute.selector);
            if (projectDetails) {
              customData[attribute.key] = this.getJobTitle(projectDetails?.project_prefix, projectDetails?.project_number, projectDetails?.project_name);
            }
          }
          else if (attribute.group_uid === 'departure') {
            let dateTime: any;
            if(additionalParams.isRecurringRoute) {
              dateTime = eventDetails?.route_start;
            }
            else {
              dateTime =  _.get(eventDetails, attribute.selector);
            }
            if (dateTime) {
              customData[attribute.key] = dayjs.utc(dateTime).tz(this.selectedTimezone[this.activeDispatchTab]).format(this.dateTimeFormat);
            }
          }
          else if (attribute.group_uid === 'work_order_customer_name') {
            const selectors = attribute.selector;
            const firstName = _.get(eventDetails, selectors[0]);
            const lastName = _.get(eventDetails, selectors[1]);
            customData[attribute.key] = this._utilityService.concatTwoStrings(firstName, lastName);
          }
          else if (attribute.group_uid === 'service_address_city_state') {
            const selectors = attribute.selector;
            const city = _.get(eventDetails, selectors[0]);
            const state = _.get(eventDetails, selectors[1]);
            customData[attribute.key] = this._utilityService.concatTwoStrings(city, state, '-');
          }
          else if (attribute.group_uid === 'work_order_skillsets') {
            const skills: string[] = _.get(eventDetails, attribute.selector) || [];
            if (skills.length > 0) {
              customData[attribute.key] = {};
              customData[attribute.key]['skill_name'] = skills[0]['skill_name'];
              customData[attribute.key]['skill_count'] = skills.length - 1;
            }
          }
          else if (attribute.group_uid === 'work_order_assigned_to') {
            const assignedTo = _.get(eventDetails, attribute.selector) || [];
            const assignedToTeam = _.get(eventDetails, 'assigned_to_team') || [];
            let profilePic = '';
            let totalAssignees = 0;
            customData[attribute.key] = {};
            if (assignedTo.length > 0) {
              const firstName = _.get(assignedTo[0], ['user', 'first_name']);
              const lastName = _.get(assignedTo[0], ['user', 'last_name']);
              customData[attribute.key]['name'] = this._utilityService.concatTwoStrings(firstName, lastName);
              profilePic = _.get(assignedTo[0], ['user', 'profile_picture']) || '';
              profilePic = profilePic.includes('profile_picture.jpg') ? '' : profilePic;
              customData[attribute.key]['profile_picture'] = profilePic;
              totalAssignees = assignedTo.length;
            } else if (assignedTo.length === 0 && assignedToTeam.length > 0) {
              customData[attribute.key]['name'] = _.get(assignedToTeam[0], ['team', 'team_name']);
              customData[attribute.key]['profile_picture'] = '';
              totalAssignees = assignedToTeam?.length;
            }
            customData[attribute.key]['count'] = totalAssignees - 1;
          }
          else if (attribute.group_uid === 'work_order_number') {
            const prefix = _.get(eventDetails, 'prefix') || '';
            const workOrderNumber = _.get(eventDetails, attribute.selector) || '';
            customData[attribute.key] = `${workOrderNumber !== '' ? '#' : ''}${prefix} ${workOrderNumber}`;
          }
          else if (attribute.group_uid === 'route_name') {
            if (additionalParams?.isRecurringRoute) {
              customData[attribute.key] = eventDetails?.recurring_route_name ?? '';
            }
            else {
              customData[attribute.key] = _.get(eventDetails, attribute.selector) ?? '';
              customData['routeDetails']['isLocked'] = eventDetails?.is_locked;
            }
          }
          else if (attribute.group_uid === 'duration' && additionalParams?.isRecurringRoute) {
              customData[attribute.key] = eventDetails?.route_duration || 0;
          }
          else if (attribute.group_uid === 'total_jobs' && additionalParams?.isRecurringRoute) {
              customData[attribute.key] = eventDetails?.total_routes || 0;
          }
          else if (attribute.group_uid === 'start_location' || attribute.group_uid === 'end_location') {
            const location = _.get(eventDetails, attribute.selector) || {};
            const address: any[] = [];
            let formatedLocation: string = '';
            if (location.street) {
              address.push(location.street);
            }
            if (location.name) {
              address.push(location.name);
            }
            if (address.length) {
              formatedLocation = address.join(', ');
              customData[attribute.key] = formatedLocation;
            }
          }
          else if (attribute.group_uid === 'transport_mode') {
            customData[attribute.key] = this.titlecasePipe.transform(_.get(eventDetails, attribute.selector) ?? '');
          }
          else if (attribute.group_uid === 'job_tags') {
            const tags = _.get(eventDetails, attribute.selector) || [];
            customData[attribute.key] = tags?.length ? tags : null;
          }
          else if (attribute.group_uid === 'duration') {
            const totalDuration = _.get(eventDetails, attribute.selector) || 0;
            customData[attribute.key] = this._utilityService.convertSecondsToHours(totalDuration * 3600);
          }
          else {
            customData[attribute.key] = _.get(eventDetails, attribute.selector) ?? '';
          }
        }
        else {

          //Custom field
          // eslint-disable-next-line @typescript-eslint/naming-convention
          eventDetails.custom_fields = eventDetails?.custom_fields.map(job => ({ ...job, group_uid: !job['group_uid'] ? '' : job['group_uid'] }));
          let searchGroupUid = attribute.group_uid;
          if (attribute.key.includes('default_uid')) {
            searchGroupUid = '';
          }

          // eslint-disable-next-line @typescript-eslint/naming-convention
          const customValue = _.find(eventDetails.custom_fields, { label: attribute.originalLabel, group_uid: searchGroupUid });
          if (customValue) {
            if (customValue.type === 'SINGLE_LINE') {
              if (this._utilityService.isURL(customValue.value)) {
                customData[attribute.key] = {};
                customData[attribute.key]['href'] = customValue.value;
              }
              else {
                customData[attribute.key] = customValue.value;
              }
            }
            else if (customValue.type === 'DATE' && !this._utilityService.isEmptyOrUndefined(customValue.value)) {
              customData[attribute.key] = this.dateFormatPipe.transform(customValue.value);
            }
            else if (customValue.type === 'TIME' && !this._utilityService.isEmptyOrUndefined(customValue.value)) {
              customData[attribute.key] = this.timeFormatPipe.transform(customValue.value, false, 'HH:mm:ss');
            }
            else if (customValue.type === 'DATETIME' && !this._utilityService.isEmptyOrUndefined(customValue.value)) {
              customData[attribute.key] = dayjs.utc(customValue.value, 'YYYY-MM-DD HH:mm:ss').tz(this.selectedTimezone[this.activeDispatchTab]).format(this.dateTimeFormat);
            }
            else if (customValue.type === 'FILE' && !this._utilityService.isEmptyOrUndefined(customValue.value)) {
              customData[attribute.key] = {};
              customData[attribute.key]['href'] = customValue.value;
            }
            else if (customValue.type === 'LOOKUP' && !this._utilityService.isEmptyOrUndefined(customValue.value)) {
              customData[attribute.key] = {};
              customData[attribute.key]['value'] = customValue.value;
              customData[attribute.key]['href'] = this._utilityService.getLink(customValue.module_name, customValue.ref_uid);
            }
            else {
              customData[attribute.key] = customValue?.value ? customValue?.value : '';
            }
          }
        }
      });
    });
    return customData;
  }

  formatEmployeeDetails(customSelectedAttributes: any, employeeDetails: any, currentData: any): any {
    if (!customSelectedAttributes) {
      return {};
    }
    const customData = {};
    customData['profile_picture'] = _.get(employeeDetails, 'imageUrl') || '';
    let customValueDetails: any = {};
    if (employeeDetails?.custom_fields?.custom_fields) {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      customValueDetails = ([...(employeeDetails?.custom_fields?.custom_fields || [])].map((job: any) => ({ ...job, group_uid: !job['group_uid'] ? '' : job['group_uid'] })));
    }
    Object.keys(customSelectedAttributes).map(key => Number(key)).forEach((rowNumber: any) => {
      customSelectedAttributes[rowNumber].forEach((attribute) => {
        if (attribute?.isDefaultField) {
          switch (attribute.group_uid) {
            case 'employee_status': {
              //TODO: yet to implement logic
              customData[attribute.key] = 'Available';
              break;
            }
            case 'employee_skillset': {
              const skills: any[] = _.get(employeeDetails, attribute.selector) || [];
              if (skills.length > 0) {
                customData[attribute.key] = {};
                customData[attribute.key]['skill_name'] = skills[0]?.skillsets.skillset_name;
                customData[attribute.key]['skill_count'] = skills.length - 1;
              }
              break;
            }
            case 'employee_work_hours': {
              const workHours: any[] = _.get(employeeDetails, attribute.selector) || [];
              if (workHours.length > 0 && currentData?.currentView === 'DAY') {
                const workHour = _.find(workHours, { 'day': currentData?.currentDay });
                if (!this._utilityService.isEmptyOrUndefined(workHour)) {
                  customData[attribute.key] = {};
                  customData[attribute.key]['start_time'] = this.timeFormatPipe.transform(workHour?.start_time, false, 'HH:mm:ss', this.selectedTimezone[this.activeDispatchTab]);
                  customData[attribute.key]['end_time'] = this.timeFormatPipe.transform(workHour?.end_time, false, 'HH:mm:ss', this.selectedTimezone[this.activeDispatchTab]);
                }
              }
              break;
            }
            case 'employee_job_count': {
              customData[attribute.key] = (currentData?.jobsCount || 0)+'';
              break;
            }
            default: {
              customData[attribute.key] = _.get(employeeDetails, attribute.selector) || '';
            }
        }
      }
        else {
          let searchGroupUid = attribute.group_uid;
          if (attribute.key.includes('default_uid')) {
            searchGroupUid = '';
          }
          // eslint-disable-next-line @typescript-eslint/naming-convention
          const customValue = _.find(customValueDetails, { label: attribute?.originalLabel, group_uid: searchGroupUid });
          if (customValue) {
            if (customValue.type === 'SINGLE_LINE') {
              if (this._utilityService.isURL(customValue.value)) {
                customData[attribute.key] = {};
                customData[attribute.key]['href'] = customValue.value;
              }
              else {
                customData[attribute.key] = customValue.value;
              }
            }
            else if (customValue.type === 'DATE' && !this._utilityService.isEmptyOrUndefined(customValue.value)) {
              customData[attribute.key] = this.dateFormatPipe.transform(customValue.value);
            }
            else if (customValue.type === 'TIME' && !this._utilityService.isEmptyOrUndefined(customValue.value)) {
              customData[attribute.key] = this.timeFormatPipe.transform(customValue.value, false, 'HH:mm:ss');
            }
            else if (customValue.type === 'DATETIME' && !this._utilityService.isEmptyOrUndefined(customValue.value)) {
              customData[attribute.key] = dayjs.utc(customValue.value, 'YYYY-MM-DD HH:mm:ss').tz(this.selectedTimezone[this.activeDispatchTab]).format(this.dateTimeFormat);
            }
            else if (customValue.type === 'FILE' && !this._utilityService.isEmptyOrUndefined(customValue.value)) {
              customData[attribute.key] = {};
              customData[attribute.key]['href'] = customValue.value;
            }
            else if (customValue.type === 'LOOKUP' && !this._utilityService.isEmptyOrUndefined(customValue.value)) {
              customData[attribute.key] = {};
              customData[attribute.key]['value'] = customValue.value;
              customData[attribute.key]['href'] = this._utilityService.getLink(customValue.module_name, customValue.ref_uid);
            }
            else {
              customData[attribute.key] = customValue?.value ? customValue?.value : '';
            }
          }
        }
      });
    });
    return customData;

  }

  isDateConflict(startDateTimeOne: any, endDateTimeOne: any, startDateTimeTwo: any, endDateTimeTwo: any): boolean {
    if (moment(startDateTimeTwo).isBetween(moment(startDateTimeOne), moment(endDateTimeOne), undefined, '[)') ||
      moment(endDateTimeTwo).isBetween(moment(startDateTimeOne), moment(endDateTimeOne), undefined, '(]') ||
      (moment(startDateTimeTwo).isBefore(moment(startDateTimeOne)) && moment(endDateTimeTwo).isAfter(moment(endDateTimeOne)))) {
      return true;
    }
    return false;
  }

  isConflictWithHolidays(startDateTime: Moment | string, endDateTime: Moment | string, onlyStrictHolidays: boolean = true): any[] {
    let isHoliday: boolean = false; let holidayNames: string = '';
    let holidaysFallsOnDate: any[] = [];
    const fromDate = moment(startDateTime).startOf('d'); const toDate = moment(endDateTime).endOf('d');
    for (let iterFromDate = fromDate.clone(); iterFromDate.isBefore(toDate); iterFromDate.add(1, 'day')) {
      const currentDate = iterFromDate.format('YYYY-MM-DD');
      if (this.holidayObj[currentDate]) {
        holidaysFallsOnDate.push(this.holidayObj[currentDate]);
      }
    }
    isHoliday = holidaysFallsOnDate?.length > 0;
    const strictHolidays: any [] = holidaysFallsOnDate.filter((holiday: any) => !holiday.allow_job) || [];
    const isJobNotAllowedHoliday: boolean = !!strictHolidays?.length;
    if (onlyStrictHolidays) {
      holidaysFallsOnDate = holidaysFallsOnDate.filter((holiday: any) => !holiday.allow_job);
    }
    holidayNames = holidaysFallsOnDate?.length > 0 ? holidaysFallsOnDate.map((holiday: any) => [holiday.holiday_name + ` (${moment.utc(holiday.date).format(this.dateFormat)})`]).join(', ') : '';
    return [isHoliday, holidayNames, isJobNotAllowedHoliday, holidaysFallsOnDate];
  }

  getBusinessHours(type: 'start' | 'end'): any {
    if (type === 'start') {
      return this.companyConfig.businessHours.start;
    } else if (type === 'end') {
      return this.companyConfig.businessHours.end;
    }
  }

  getScheduleWarningMsg(eventType: 'job' | 'route' | 'nonJobEvent', eventDetails: any, userDetails: any, startDateTime: any, endDateTime: any, customUserDetails: any, showAllWarnings: boolean, onlyOverDueAndTimeoff?: boolean, additionalParams?: any): any {
    this.eventType = eventType;
    this.eventDetails = eventDetails;
    this.userDetails = userDetails;
    this.customUserDetails = customUserDetails;
    this.startDateTime = startDateTime;
    this.endDateTime = endDateTime;
    this.warningTimezone = additionalParams?.timezone || this.selectedTimezone[this.activeDispatchTab] || this._utilityService.timeZone || moment.tz.guess();
    this.eventAssignedTo = this.eventDetails?.assigned_to?.map((assignee: any) => ({ 'userUid': assignee?.user?.user_uid, 'name': this._utilityService.concatTwoStrings(assignee?.user?.first_name, assignee?.user?.last_name), 'work_hours': assignee?.user?.work_hours }));
    if (this.userDetails?.user_uid) {
      const isUserAlreadyAssigned = this.eventAssignedTo.some(assignee => assignee.userUid === this.userDetails?.user_uid);
      if (!isUserAlreadyAssigned) {
        const toBeAssignedUser = { userUid: this.userDetails?.user_uid, name: this._utilityService.concatTwoStrings(this.userDetails?.first_name, this.userDetails?.last_name), work_hours: this.userDetails?.work_hours };
        this.eventAssignedTo.push(toBeAssignedUser);
      }
    }
    this.resetWarnings();
    if (eventDetails) {
      if (showAllWarnings) {
        this.checkForTimeOff();
        this.checkEventOverlaps();
        this.checkNonJobEventOverlaps();
        this.checkForHoliday();
        this.checkBusinessAndWorkHours();
        this.checkDueDate();
        this.checkShiftHours();
        this.checkRouteDurationExceed(additionalParams);
        this.checkRouteJobScheduleConflict(additionalParams);
      }
      else if (onlyOverDueAndTimeoff) {
        this.checkForTimeOff();
        this.checkEventOverlaps();
        this.checkNonJobEventOverlaps();
        this.checkShiftHours();
        this.checkRouteDurationExceed(additionalParams);
        this.checkRouteJobScheduleConflict(additionalParams);
      }
      else {
        this.checkForHoliday();
        this.checkBusinessAndWorkHours();
        this.checkDueDate();
        this.checkShiftHours();
        this.checkEventOverlaps();
        this.checkNonJobEventOverlaps();
        this.checkRouteDurationExceed(additionalParams);
        this.checkRouteJobScheduleConflict(additionalParams);
      }
    }
    return {
      dateWarnings: this.dateWarnings,
      timeWarnings: this.timeWarnings,
      dueDateWarning: this.dueDateWarning,
      eventOverlapWarning: this.eventOverlapWarning,
      nonJobEventOverlapWarning: this.nonJobEventOverlapWarning,
      shiftHoursExceedWarning: this.shiftHoursExceedWarning,
      routeDurationExceedWarning: this.routeDurationExceedWarning,
      routeJobScheduleConflictWarning: this.routeJobScheduleConflictWarning
    };
  }

  resetWarnings(): any {
    this.warnings = { holiday: false, dueDate: false, businessHours: false, workHours: false, timeoff: false, overlap: false, nonJobEventOverlap: false, shiftHours: false, routeDuration: false, routeJobScheduleConflict: false };
    this.timeWarnings = { show: false, msg: '' };
    this.dateWarnings = { show: false, msg: '' };
    this.dueDateWarning = { show: false, msg: '' };
    this.eventOverlapWarning = { show: false, msg: '' };
    this.shiftHoursExceedWarning = { show: false, msg: '' };
    this.routeDurationExceedWarning = { show: false, msg: '' };
    this.routeJobScheduleConflictWarning = { show: false, msg: '' };
    this.nonJobEventOverlapWarning = { show: false, msg: '' };
  }

  checkForHoliday(): void {
    let isHoliday = false;
    [isHoliday, this.holidayName] = this.isConflictWithHolidays(this.startDateTime, this.endDateTime, false);
    this.warnings.holiday = isHoliday;
    this.setHolidayWarningMsg();
  }

  checkForTimeOff(): void {
    if (this.companyConfig.orgConfigJobTimeoffAlert) {
      const customUserDetails = this.customUserDetails;
      const assigneeDetails = this.eventAssignedTo;
      this.timeOffUsers = [];
      const fromDate = moment.tz(this.startDateTime.format('YYYY-MM-DD HH:mm'), 'YYYY-MM-DD HH:mm',  this.warningTimezone); const toDate = moment.tz(this.endDateTime.format('YYYY-MM-DD HH:mm'), 'YYYY-MM-DD HH:mm', this.warningTimezone);
      for (let iterFromDate = fromDate.clone().startOf('d'); iterFromDate.isSameOrBefore(moment(toDate.toISOString()).clone().endOf('d')); iterFromDate.add(1, 'day')) {
        assigneeDetails?.forEach((assignee: any) => {
          const _date = `${iterFromDate.format('YYYY-MM-DD')}`;
          const userDetails = customUserDetails?.[`${_date}_${assignee?.userUid}`];
          if (!this._utilityService.isEmptyOrUndefined(userDetails)) {
            userDetails?.timeOff?.forEach((request: any) => {
              if (this.isDateConflict(fromDate, toDate, moment(request?.request_from), moment(request?.request_to))) {
                this.timeOffUsers.push(assignee?.name);
              }
            });
          }
        });
      }
      this.warnings.timeoff = this.timeOffUsers.length > 0;
      this.setTimeoffWarningMsg();
    }
  }

  checkBusinessAndWorkHours(): void {
    const timeFormat = 'HH:mm:ss';
    const startTime = moment(this.startDateTime.format(timeFormat), timeFormat);
    const endTime = moment(this.endDateTime.format(timeFormat), timeFormat);
    const isSameDayJob = this.startDateTime.isSame(this.endDateTime, 'date');
    const pastWorkHourUsers: any[] = [];

    if (isSameDayJob) {

      //Business hours
      let isPastBusinessHours = false;
      const businessStartTime = moment(this.getBusinessHours('start'), timeFormat);
      const businessEndTime = moment(this.getBusinessHours('end'), timeFormat);
      const adjustedStartTime = moment(startTime.format(timeFormat), timeFormat);
      const adjustedEndTime = moment(endTime.format(timeFormat), timeFormat);
      if (!adjustedStartTime.isBetween(businessStartTime, businessEndTime, undefined, '[)') || !adjustedEndTime.isBetween(businessStartTime, businessEndTime, undefined, '(]')) {
        isPastBusinessHours = true;
      }
      this.warnings.businessHours = isPastBusinessHours;

      //Work hours
      // eslint-disable-next-line @typescript-eslint/naming-convention
      const assigneeDetails = this.eventAssignedTo;
      assigneeDetails?.forEach((assignee: any) => {
        const workHours = assignee?.work_hours;
        let isPastWorkHours = false;
        let workStartTime = _.find(workHours, { 'day': this.startDateTime.format('dddd') })?.start_time;
        let workEndTime = _.find(workHours, { 'day': this.endDateTime.format('dddd') })?.end_time;
        if (!this._utilityService.isEmptyOrUndefined(workStartTime) && !this._utilityService.isEmptyOrUndefined(workEndTime)) {
          workStartTime = moment(moment(workStartTime, 'hh:mm A').tz(this.warningTimezone).format('HH:mm:ss'), 'HH:mm:ss');
          workEndTime = moment(moment(workEndTime, 'hh:mm A').tz(this.warningTimezone).format('HH:mm:ss'), 'HH:mm:ss');
          if (workStartTime.isAfter(workEndTime)) {
            workStartTime = workStartTime.subtract(1, 'day');
          }
          if (!startTime.isBetween(workStartTime, workEndTime, undefined, '[)') || !endTime.isBetween(workStartTime, workEndTime, undefined, '(]')) {
            isPastWorkHours = true;
          }
        }
        if (isPastWorkHours) {
          pastWorkHourUsers.push(assignee?.name);
        }
      });

      this.warnings.workHours = !!pastWorkHourUsers?.length;
    }
    else {
      this.warnings.businessHours = false;
      this.warnings.workHours = false;
    }
    this.setBusinessHoursWarningMsg();
    this.setWorkHoursWarningMsg(pastWorkHourUsers);
  }

  checkDueDate(): void {
    let dueDate = this.eventDetails?.due_date;
    let isPastDue = false;
    if (!this._utilityService.isEmptyOrUndefined(dueDate)) {
      dueDate = moment(dueDate).endOf('day');
      if (moment(this.endDateTime).isAfter(dueDate)) {
        isPastDue = true;
        this.dueDate = dueDate;
      }
    }
    this.warnings.dueDate = isPastDue;
    this.setDueDateWarningMsg();
  }

  checkEventOverlaps(): void {
    if (this.companyConfig.orgConfigJobTimeoffAlert) {
      const customUserDetails = this.customUserDetails;
      const assigneeDetails: any[] = this.eventAssignedTo;
      this.jobOverlapUsers = [];
      const fromDate = moment.tz(this.startDateTime.format('YYYY-MM-DD HH:mm'), 'YYYY-MM-DD HH:mm', this.warningTimezone); const toDate = moment.tz(this.endDateTime.format('YYYY-MM-DD HH:mm'), 'YYYY-MM-DD HH:mm', this.warningTimezone);
      for (let iterFromDate = fromDate.clone().startOf('d'); iterFromDate.isSameOrBefore(moment(toDate.toISOString()).clone().endOf('d')); iterFromDate.add(1, 'day')) {
        assigneeDetails?.forEach((assignee: any) => {
          const _date = `${iterFromDate.format('YYYY-MM-DD')}`;
          const userDetails = customUserDetails?.[`${_date}_${assignee?.userUid}`];
          if (!this._utilityService.isEmptyOrUndefined(userDetails)) {
            userDetails?.jobs?.forEach((event: any) => {
              if (this.eventType === 'route') {
                if (!this._utilityService.isEmptyOrUndefined(event?.departure) && !this._utilityService.isEmptyOrUndefined(event?.route_end_time)) {
                  if (this.isDateConflict(fromDate, toDate, moment(event?.departure), moment(event?.route_end_time)) && (event?.route_uid !== this.eventDetails?.route_uid)) {
                    this.jobOverlapUsers.push(assignee?.name);
                  }
                }
              }
              else {
                if (!this._utilityService.isEmptyOrUndefined(event?.scheduled_start_time) && !this._utilityService.isEmptyOrUndefined(event?.scheduled_end_time)) {
                  if (this.isDateConflict(fromDate, toDate, moment(event?.scheduled_start_time), moment(event?.scheduled_end_time)) && (event.job_uid !== this.eventDetails?.job_uid)) {
                    this.jobOverlapUsers.push(assignee?.name);
                  }
                }
              }
            });
          }
        });
      }
      this.warnings.overlap = this.jobOverlapUsers.length > 0;
      this.setEventOverlapWarningMsg();
    }
  }

  checkNonJobEventOverlaps(): void {
    if (this.companyConfig.orgConfigJobTimeoffAlert) {
      const customUserDetails = this.customUserDetails;
      const assigneeDetails: any[] = this.eventAssignedTo;
      this.nonJobOverlapUsers = [];
      const fromDate = moment.tz(this.startDateTime.format('YYYY-MM-DD HH:mm'), 'YYYY-MM-DD HH:mm', this.warningTimezone); const toDate = moment.tz(this.endDateTime.format('YYYY-MM-DD HH:mm'), 'YYYY-MM-DD HH:mm', this.warningTimezone);
      for (let iterFromDate = fromDate.clone().startOf('d'); iterFromDate.isSameOrBefore(moment(toDate.toISOString()).clone().endOf('d')); iterFromDate = iterFromDate.clone().add(1, 'day')) {
        assigneeDetails?.forEach((assignee: any) => {
          const _date = `${iterFromDate.format('YYYY-MM-DD')}`;
          const userDetails = customUserDetails?.[`${_date}_${assignee?.userUid}`];
          if (!this._utilityService.isEmptyOrUndefined(userDetails)) {
            userDetails?.nonJobEvents?.forEach((event: any) => {
                if (!this._utilityService.isEmptyOrUndefined(event?.start_time) && !this._utilityService.isEmptyOrUndefined(event?.end_time)) {
                  if (this.isDateConflict(fromDate, toDate, moment.utc(event?.start_time), moment.utc(event?.end_time)) && event?.event_uid !== this.eventDetails?.event_uid) {
                    this.nonJobOverlapUsers.push(assignee?.name);
                  }
              }
            });
          }
        });
      }
      this.warnings.nonJobEventOverlap = this.nonJobOverlapUsers?.length > 0;
      this.setNonJobEventOverlapWarningMsg();
    }
  }

  checkShiftHours(): void {
    const customUserDetails = this.customUserDetails;
    const assigneeDetails = this.eventAssignedTo;
    this.shiftHoursExceedUsers = [];
    const fromDate = moment.tz(this.startDateTime.format('YYYY-MM-DD HH:mm'),  'YYYY-MM-DD HH:mm', this.warningTimezone).utc(false); const toDate = moment.tz(this.endDateTime.format('YYYY-MM-DD HH:mm'),'YYYY-MM-DD HH:mm', this.warningTimezone).utc(false);
    for (let iterFromDate = fromDate.clone().startOf('d'); iterFromDate.isSameOrBefore(moment(toDate.toISOString()).clone().endOf('d')); iterFromDate.add(1, 'day')) {
      assigneeDetails?.forEach((assignee: any) => {
        const _date = `${iterFromDate.format('YYYY-MM-DD')}`;
        const userDetails = customUserDetails?.[`${_date}_${assignee?.userUid}`];
        if (!this._utilityService.isEmptyOrUndefined(userDetails)) {
          let showWarning: boolean = false;
          const shiftTracker: boolean[] = [];
          _.forEach(userDetails?.shiftHours, ((shift: any) => {
            if (!this._utilityService.isEmptyOrUndefined(shift?.start_date_time) && !this._utilityService.isEmptyOrUndefined(shift?.end_date_time)) {
              const shiftStartTime = moment.utc(shift?.start_date_time);
              const shiftEndTime = moment.utc(shift?.end_date_time);
              const isJobInNonShiftHours = !fromDate.isBetween(shiftStartTime, shiftEndTime, null, '[]') || !toDate.isBetween(shiftStartTime, shiftEndTime, null, '[]');
              shiftTracker.push(isJobInNonShiftHours);
            }
          }));
          if(shiftTracker.length) {
            showWarning =  shiftTracker.filter((status: boolean) => !status).length === 0;
          }
          if (showWarning) {
            this.shiftHoursExceedUsers.push(assignee?.name);
          }
        }
      });
    }
    this.warnings.shiftHours = this.shiftHoursExceedUsers.length > 0;
    this.setShiftHoursExceedWarningMsg();
  }

  checkRouteDurationExceed(additionalParams: any): void {
    let routeDurationExceed: boolean = false;
    let routeStartDateTime: any;
    let routeEndDateTime: any;
    const routeDetails = { ...additionalParams?.routeDetails };
    if (additionalParams?.checkRouteDurationExceed) {
      const routeDuration = routeDetails?.duration || 1;
      const startDateTime = moment.tz(this.startDateTime.format('YYYY-MM-DD HH:mm:ss'), this.warningTimezone); const endDateTime = moment.tz(this.endDateTime.format('YYYY-MM-DD HH:mm:ss'), this.warningTimezone);
      routeStartDateTime = moment.utc(routeDetails?.departure);
      routeEndDateTime = routeStartDateTime.clone().add(routeDuration, 'h');
      if (!startDateTime.isBetween(routeStartDateTime, routeEndDateTime, null, '[]') || !endDateTime.isBetween(routeStartDateTime, routeEndDateTime, null, '[]')) {
        routeDurationExceed = true;
      }
    }
    this.warnings.routeDuration = routeDurationExceed;
    this.setRouteDurationExceedWarningMsg(routeStartDateTime, routeEndDateTime, routeDetails?.route_name);
  }

  checkRouteJobScheduleConflict(additionalParams: any): void {
    if (additionalParams?.checkRouteJobConflict && this.companyConfig.orgConfigJobTimeoffAlert) {
      const routeDetails = additionalParams?.routeDetails;
      const routeJobs = routeDetails?.jobs || [];
      if (routeJobs.length > 0) {
        const customJobDetails = [];
        routeJobs.forEach((routeJob: any) => {
          if (routeJob?.job && routeJob?.job.job_uid !== this.eventDetails?.job_uid) {
            customJobDetails.push({ startDate: moment.utc(routeJob?.job?.scheduled_start_time), endDate: moment.utc(routeJob?.job?.scheduled_end_time), id: routeJob?.job.job_uid, jobTitle: routeJob?.job.job_title, prefix: routeJob?.job.prefix || '', workOrderNumber: routeJob?.job.work_order_number });
          }
        });
        if (customJobDetails.length > 0) {
          const jobConflictDetails = [];
          customJobDetails.forEach((customJobDetail: any) => {
            const startDateTime = moment.tz(this.startDateTime.format('YYYY-MM-DD HH:mm:ss'), this.warningTimezone); const endDateTime = moment.tz(this.endDateTime.format('YYYY-MM-DD HH:mm:ss'), this.warningTimezone);
            if (this.isDateConflict(startDateTime.clone(), endDateTime.clone(), customJobDetail?.startDate, customJobDetail?.endDate)) {
              jobConflictDetails.push(customJobDetail);
            }
          });
          this.warnings.routeJobScheduleConflict = jobConflictDetails.length > 0;
          this.setRouteJobScheduleConflictWarningMsg(jobConflictDetails);
        }
      }
    }
  }

  setTimeoffWarningMsg(): void {
    if (this.warnings.timeoff) {
      this.dateWarnings.show = true;
      if (this.eventType === 'job') {
        this.dateWarnings.msg = `${this._utilityService.getLocaleValue('dispatchBoard.scheduler.reschedule.warnings.timeoff', 'Job is scheduled on a Time-off for the user(s)')} : ${_.uniq(this.timeOffUsers).join(', ')}`;
      }
      else if (this.eventType === 'route') {
        this.dateWarnings.msg = `${this._utilityService.getLocaleValue('dispatchBoard.scheduler.reschedule_route.warnings.timeoff', 'Route is scheduled on a Time-off for the user(s)')} : ${_.uniq(this.timeOffUsers).join(', ')}`;
      }
      else if (this.eventType === 'nonJobEvent') {
        this.dateWarnings.msg = `${this._utilityService.getLocaleValue('dispatchBoard.scheduler.reschedule_non_job_event.warnings.timeoff', 'The event is scheduled on a Time-off for the user(s)')} : ${_.uniq(this.timeOffUsers).join(', ')}`;
      }
    }
  }

  setHolidayWarningMsg(): void {
    if (!this.warnings.timeoff && this.warnings.holiday) {
      this.dateWarnings.show = true;
      if (this.eventType === 'job') {
        this.dateWarnings.msg = `${this._utilityService.getLocaleValue('dispatchBoard.scheduler.reschedule.warnings.holiday', 'Job is scheduled on a holiday')} : (${this.holidayName})`;
      }
      else if (this.eventType === 'route') {
        this.dateWarnings.msg = `${this._utilityService.getLocaleValue('dispatchBoard.scheduler.reschedule_route.warnings.holiday', 'Route is scheduled on a holiday')} : (${this.holidayName})`;
      }
      else if (this.eventType === 'nonJobEvent') {
        this.dateWarnings.msg = `${this._utilityService.getLocaleValue('dispatchBoard.scheduler.reschedule_non_job_event.warnings.holiday', 'The Event is scheduled on a holiday')} : (${this.holidayName})`;
      }
    }
  }

  setBusinessHoursWarningMsg(): void {
    if (this.warnings.businessHours) {
      this.timeWarnings.show = true;
      if (this.eventType === 'job') {
        this.timeWarnings.msg =this._utilityService.getLocaleValue('dispatchBoard.scheduler.reschedule.warnings.business_hours', 'Job is scheduled outside business hours');
      }
      else if (this.eventType === 'route') {
        this.timeWarnings.msg =   this._utilityService.getLocaleValue('dispatchBoard.scheduler.reschedule_route.warnings.business_hours', 'Route is scheduled outside business hours');
      }
      else if (this.eventType === 'nonJobEvent') {
        this.timeWarnings.msg =   this._utilityService.getLocaleValue('dispatchBoard.scheduler.reschedule_non_job_event.warnings.business_hours', 'The event is scheduled outside business hours');
      }
    }
  }

  setWorkHoursWarningMsg(pastWorkHourUsers: string[]): void {
    if (this.warnings.workHours && pastWorkHourUsers?.length) {
      this.timeWarnings.show = true;
      if (this.eventType === 'job') {
        this.timeWarnings.msg = `${this._utilityService.getLocaleValue('dispatchBoard.scheduler.reschedule.warnings.work_hours', 'Job is scheduled outside work hours of user(s)')} ${pastWorkHourUsers.join(', ')}`;
      }
      else if (this.eventType === 'route') {
        this.timeWarnings.msg = `${this._utilityService.getLocaleValue('dispatchBoard.scheduler.reschedule_route.warnings.work_hours', 'Route is scheduled outside work hours of user(s)')} ${pastWorkHourUsers.join(', ')}`;
      }
      else if (this.eventType === 'nonJobEvent') {
        this.timeWarnings.msg = `${this._utilityService.getLocaleValue('dispatchBoard.scheduler.reschedule_non_job_event.warnings.work_hours', 'The event is scheduled outside the work hours of the user(s)')} ${pastWorkHourUsers.join(', ')}`;
      }
    }
  }

  setDueDateWarningMsg(): void {
    if (this.warnings.dueDate) {
      this.dueDateWarning.show = true;
      this.dueDateWarning.msg =
        `${this._utilityService.getLocaleValue('dispatchBoard.scheduler.reschedule.warnings.duedate', 'Job is due by')} ${this.dueDate.format(this.dateFormat)}`;
    }
  }

  setEventOverlapWarningMsg(): void {
    if (this.warnings.overlap) {
      this.eventOverlapWarning.show = true;
      if (this.eventType === 'job' || this.eventType === 'nonJobEvent') {
        this.eventOverlapWarning.msg = `${_.uniq(this.jobOverlapUsers).join(', ')} ${this._utilityService.getLocaleValue('dispatchBoard.scheduler.reschedule.warnings.overlap', 'has already been assigned to another job in this time interval')}`;
      }
      else if (this.eventType === 'route') {
        this.eventOverlapWarning.msg = `${_.uniq(this.jobOverlapUsers).join(', ')} ${this._utilityService.getLocaleValue('dispatchBoard.scheduler.reschedule_route.warnings.overlap', 'has already been assigned to another route in this time interval')}`;
      }
    }
  }

  setNonJobEventOverlapWarningMsg(): void {
    if (this.warnings.nonJobEventOverlap) {
      this.nonJobEventOverlapWarning.show = true;
      this.nonJobEventOverlapWarning.msg =
        ` ${_.uniq(this.nonJobOverlapUsers).join(', ')} ${this._utilityService.getLocaleValue('dispatchBoard.scheduler.reschedule.warnings.non_job_event_overlap', ' has already been assigned to a non-job event during this time interval.')}`;
    }
  }

  setShiftHoursExceedWarningMsg(): void {
    if (this.warnings.shiftHours) {
      this.shiftHoursExceedWarning.show = true;
      if (this.eventType === 'job') {
        this.shiftHoursExceedWarning.msg = `${this._utilityService.getLocaleValue('dispatchBoard.scheduler.reschedule.warnings.shift_hours_exceed', 'Job is scheduled outside the shift hours of the user(s)')} ${_.uniq(this.shiftHoursExceedUsers).join(', ')}`;
      }
      else if (this.eventType === 'route') {
        this.shiftHoursExceedWarning.msg = `${this._utilityService.getLocaleValue('dispatchBoard.scheduler.reschedule_route.warnings.shift_hours_exceed', 'Route is scheduled outside the shift hours of the user(s)')} ${_.uniq(this.shiftHoursExceedUsers).join(', ')}`;
      }
      else if (this.eventType === 'nonJobEvent') {
        this.shiftHoursExceedWarning.msg = `${this._utilityService.getLocaleValue('dispatchBoard.scheduler.reschedule.warnings_non_job_event.shift_hours_exceed', 'The event is scheduled outside the shift hours of the user(s)')} ${_.uniq(this.shiftHoursExceedUsers).join(', ')}`;
      }
    }
  }

  setRouteDurationExceedWarningMsg(routeStartDateTime: any, routeEndDateTime: any, routeName: string): void {
    if (this.warnings.routeDuration) {
      const routeStartEndDuration = this.getStartEndTime(routeStartDateTime, routeEndDateTime, false);
      this.routeDurationExceedWarning.show = true;
      this.routeDurationExceedWarning.msg = `${this._utilityService.getLocaleValue('dispatchBoard.scheduler.reschedule.warnings.route_duration_exceed', 'Job is scheduled outside the route duration')} (${this.titlecasePipe.transform(routeName)} : ${routeStartEndDuration[0]} to ${routeStartEndDuration[1]})`;
    }
  }

  setRouteJobScheduleConflictWarningMsg(customJobConflictDetails: any): void {
    if (this.warnings.routeJobScheduleConflict && customJobConflictDetails.length > 0) {
      this.routeJobScheduleConflictWarning.show = true;
      const additionalJobConflictMsg = [];
      this.routeJobScheduleConflictWarning.msg = this._utilityService.getLocaleValue('alert.conflicting_job_schedule', 'Conflicting job schedule');
      customJobConflictDetails?.forEach((customJobConflictDetail: any) => {
        const startEndTime = this.getStartEndTime(customJobConflictDetail.startDate, customJobConflictDetail.endDate, false);
        additionalJobConflictMsg.push(`${this.getJobTitle(customJobConflictDetail.prefix, customJobConflictDetail.workOrderNumber, customJobConflictDetail.jobTitle)} (${startEndTime[0]} to ${startEndTime[1]})`);
      });
      this.routeJobScheduleConflictWarning.msg += ': ' + additionalJobConflictMsg.join(', ');
    }
  }

  formatScheduleWarnings(warnings: any, onlyOverDueAndTimeoff?: boolean): string {
    const warningMsg = [];

    //Only over due warnings
    if (onlyOverDueAndTimeoff) {
      if (warnings.routeDurationExceedWarning.show) {
        warningMsg.push(warnings?.routeDurationExceedWarning.msg);
      }
      else {
        if (warnings?.eventOverlapWarning.show) {
          warningMsg.push(warnings?.eventOverlapWarning.msg);
        }
        if (warnings?.nonJobEventOverlapWarning.show) {
          warningMsg.push(warnings?.nonJobEventOverlapWarning.msg);
        }
        if (warnings?.dateWarnings.show) {
          warningMsg.push(warnings?.dateWarnings.msg);
        }
      }
      if (warnings.routeJobScheduleConflictWarning.show) {
        warningMsg.push(warnings?.routeJobScheduleConflictWarning.msg);
      }
      const formatedOverDueWarnings = warningMsg.map((msg: string) => `<p>${msg}</p>`).join('');
      return formatedOverDueWarnings;
    }

    //Format all type of warnings
    if (warnings.routeDurationExceedWarning.show) {
      warningMsg.push(warnings?.routeDurationExceedWarning.msg);
    } else if (warnings?.dateWarnings.show) {
      warningMsg.push(warnings?.dateWarnings.msg);
    }
    else if (warnings?.shiftHoursExceedWarning.show) {
      warningMsg.push(warnings?.shiftHoursExceedWarning.msg);
    }
    else if (warnings?.timeWarnings.show) {
      warningMsg.push(warnings?.timeWarnings.msg);
    }

    if (warnings?.dueDateWarning.show) {
      warningMsg.push(warnings?.dueDateWarning.msg);
    }

    if (warnings?.eventOverlapWarning.show) {
      warningMsg.push(warnings?.eventOverlapWarning.msg);
    }
    if (warnings?.nonJobEventOverlapWarning.show) {
      warningMsg.push(warnings?.nonJobEventOverlapWarning.msg);
    }
    if (warnings.routeJobScheduleConflictWarning.show) {
      warningMsg.push(warnings?.routeJobScheduleConflictWarning.msg);
    }

    const formatedWarnings = warningMsg.map((msg: string) => `<p>${msg}</p>`).join('');
    return formatedWarnings;
  }

  updateUserTimeOffInUserDetails(action: 'edit' | 'delete', schedulerEmployees: any[], userUid: string, timeoffUid: string, updatedTimeoffDetails: any): any[] {
    schedulerEmployees = schedulerEmployees.map((userDetails: any) => {
      if (userDetails?.user_uid === userUid && userDetails?.timeoff_request?.length ) {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const timeoffIndex = _.findIndex(userDetails.timeoff_request, { request_uid: timeoffUid });
        if (action === 'edit' && timeoffIndex !== -1 && updatedTimeoffDetails) {
          userDetails.timeoff_request.splice(timeoffIndex, 1, updatedTimeoffDetails);
        }
        else if (action === 'delete' && timeoffIndex !== -1) {
          userDetails.timeoff_request.splice(timeoffIndex, 1);
        }
      }
      return userDetails;
    });
    return schedulerEmployees;
  }

  getJobUpdateUrl(jobUid: string): string {
    return `${this._dataCollectorService.baseurl()}/jobs/${jobUid}/update`;
  }

  getJobDeleteUrl(jobUid: string): string {
    return `${this._dataCollectorService.baseurl()}/jobs/${jobUid}/delete`;
  }

  getRouteUpdateUrl(routeUid: string): string {
    return `${this._dataCollectorService.baseurl()}/routes/${routeUid}`;
  }

  getAssignRouteUrl(routeUid: string): string {
    return `${this._dataCollectorService.baseurl()}/routes/${routeUid}/assign`;
  }

  getUnassignRouteUrl(routeUid: string): string {
    return `${this._dataCollectorService.baseurl()}/routes/${routeUid}/unassign`;
  }

  getReassignRouteUrl(routeUid: string): string {
    return `${this._dataCollectorService.baseurl()}/routes/${routeUid}/reassign`;
  }

  getUpdateRouteJobUrl(routeUid: string): string {
    return `${this._dataCollectorService.baseurl()}/routes/${routeUid}/job`;
  }

  getRouteOptimizeUrl(routeUid: string): string {
    return `${this._dataCollectorService.baseurl()}/routes/${routeUid}/optimize`;
  }

  getNearByUrl(): string {
    return `${this._dataCollectorService.baseurl()}/location/nearby`;
  }

  getRouteLockUrl(routeUid: string, isLocked: any): string {
    return `${this._dataCollectorService.baseurl()}/routes/${routeUid}/lock?is_locked=${isLocked}`;
  }

  getModuleFilters(module: string): any {
    return `${this._dataCollectorService.baseurl()}/${module}/meta/filter`;
  }

  getSchedulePayload(scheduledStartTime: any, scheduledEndTime: any, type: 'SCHEDULE' | 'RESCHEDULE', reason?: string): any {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const payload = { scheduled_start_time: scheduledStartTime, scheduled_end_time: scheduledEndTime, type: type };
    if (!this._utilityService.isEmptyOrUndefined(reason)) {
      payload['reason'] = reason;
    }
    return payload;
  }

  getAssignPayload(userUid: any, teamUid: any, type: 'ASSIGN' | 'UNASSIGN'): any {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    return { user_uid: userUid, team_uid: teamUid, type: type };
  }

  assignJob(jobUid: any, userUid: any, teamUid: any, statusCallback: (status: boolean) => void): void {
    const payload = {
      'job': [this.getAssignPayload(userUid, teamUid, 'ASSIGN')]
    };
    this.updateJobDetails(jobUid, payload, (status: boolean) => {
      statusCallback(status);
    });
  }

  unassignJob(jobUid: any, userUid: any, teamUid: any, statusCallback: (status: boolean) => void): void {
    const payload = {
      'job': [this.getAssignPayload(userUid, teamUid, 'UNASSIGN')]
    };
    this.updateJobDetails(jobUid, payload, (status: boolean) => {
      statusCallback(status);
    });
  }

  assignAndUnassignJob(jobUid: any, newUserUid: any, newUserTeamUid: any, oldUserUid: any, oldUserTeamUid: any, statusCallback: (status: boolean) => void): void {
    const payload = {
      'job': [this.getAssignPayload(newUserUid, newUserTeamUid, 'ASSIGN'),
      this.getAssignPayload(oldUserUid, oldUserTeamUid, 'UNASSIGN')]
    };
    this.updateJobDetails(jobUid, payload, (status: boolean) => {
      statusCallback(status);
    });
  }

  scheduleAndAssignJob(jobUid: any, scheduledStartTime: any, scheduledEndTime: any, type: 'SCHEDULE' | 'RESCHEDULE', reason: any, assignments: { userUid: any, teamUid: any, type: 'ASSIGN' | 'UNASSIGN' }[], statusCallback?: (status: boolean) => void): void {
    const payload = {
      job: [this.getSchedulePayload(scheduledStartTime, scheduledEndTime, type, reason)]
    };
    assignments.forEach(assignment => {
      if (assignment.userUid && assignment.teamUid && assignment.type) {
        payload.job.push(this.getAssignPayload(assignment.userUid, assignment.teamUid, assignment.type));
      }
    });
    this.updateJobDetails(jobUid, payload, (status: boolean) => {
      if (statusCallback) {
        statusCallback(status);
      }
    });
  }

  scheduleAssignAndUnassignJob(jobUid: any, scheduledStartTime: any, scheduledEndTime: any, type: 'SCHEDULE' | 'RESCHEDULE', reason: any, newUserUid: any, newUserTeamUid: any, oldUserUid: any, oldUserTeamUid: any, statusCallback: (status: boolean) => void): void {
    const payload = {
      job: [this.getSchedulePayload(scheduledStartTime, scheduledEndTime, type, reason),
      this.getAssignPayload(newUserUid, newUserTeamUid, 'ASSIGN'),
      this.getAssignPayload(oldUserUid, oldUserTeamUid, 'UNASSIGN')]
    };
    this.updateJobDetails(jobUid, payload, (status: boolean) => {
      statusCallback(status);
    });
  }

  unassignNonJobEvent(nonJobEventUid: string, unassignUser: { userUid: string; teamUid: string }, allAssignments: any[], recurrenceType: any, statusCallback: (status: boolean) => void): void {
    if (!nonJobEventUid || !unassignUser.userUid || !allAssignments?.length) {
      statusCallback(false);
    }
    let isUserAlreadyAssigned: boolean = false;
    const updatedUserAssignment: any[] = allAssignments.filter((userDetails: any) => {
      if ((unassignUser.userUid === userDetails?.user?.user_uid || userDetails?.user_uid)) {
        isUserAlreadyAssigned = true;
        return false;
      };
      return true;
    });
    if (isUserAlreadyAssigned) {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      const assignedTo: any[] = updatedUserAssignment.map((userDetails: any) => ({ user_uid: userDetails?.user?.user_uid || userDetails?.user_uid, team_uid: userDetails?.teams?.[0]?.team_uid || userDetails?.team?.team_uid })) || [];
      const payload = {
        event: {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          assigned_to: assignedTo,
        }
      };
      if (recurrenceType) {
        payload['update_recurrence_type'] = recurrenceType;
      }
      const updatingEventToastRef = this._toastService.loading(this._utilityService.getLocaleValue('non_job_event.updating.toast'));
      const nonJobEventUrl = `${this._dataCollectorService.baseurl()}/non_job_events/${nonJobEventUid}`;
      this._dataCollectorService.putData(nonJobEventUrl, payload).subscribe(
        (response: any) => {
          updatingEventToastRef.close();
          statusCallback(true);
        }, (error) => {
          updatingEventToastRef.close();
          statusCallback(false);
        });
    }
    else {
      statusCallback(false);
    }
  }

  deleteJob(jobUid: any, statusCallback: (status: boolean) => void): void {
    this._dataCollectorService.deleteData(this.getJobDeleteUrl(jobUid))
      .subscribe((response: any) => {
        this._toastService.success(response?.message);
        statusCallback(true);
      }, (error: any) => {
        statusCallback(false);
      });
  }

  deleteNonJobEvent(nonJobEventUid: any, param: any, statusCallback: (status: boolean) => void): void {
    if (!nonJobEventUid) {
      statusCallback(false);
    }
    const deleteNonJobEventUrl: string = `${this._dataCollectorService.baseurl()}/non_job_events/${nonJobEventUid}`;
    this._dataCollectorService.deleteData(deleteNonJobEventUrl, param)
      .subscribe((response: any) => {
        this._toastService.success(response?.message);
        statusCallback(true);
      }, (error: any) => {
        statusCallback(false);
      });
  }

  deleteRoute(routeUid: any, statusCallback: (status: boolean) => void): void {
    this._dataCollectorService.deleteData(this.getRouteUpdateUrl(routeUid))
      .subscribe((response: any) => {
        this._toastService.success(response?.message);
        statusCallback(true);
      }, (error: any) => {
        statusCallback(false);
      });
  }

  removeJobFromRoute(routeUid: any, removeJobParam: any, statusCallback: (status: boolean) => void): void {
    this._dataCollectorService.deleteDataPayload(this.getUpdateRouteJobUrl(routeUid), removeJobParam)
      .subscribe((response: any) => {
        this._toastService.success(response?.message);
        statusCallback(true);
      }, (error: any) => {
        statusCallback(false);
      });
  }

  updateRoute(routeUid: string, params: any, showSuccessToast: boolean, statusCallback: (status: boolean) => void): void {
    this._dataCollectorService.putData(this.getRouteUpdateUrl(routeUid), params)
      .subscribe((response: any) => {
        if (showSuccessToast) {
          this._toastService.success(response?.message);
        }
        statusCallback(true);
      }, (error: any) => {
        statusCallback(false);
      });
  }

  getRouteDetails(routeUid: string): Observable<any> {
    return this._dataCollectorService.getData(this.getRouteUpdateUrl(routeUid));
  }

  assignRoute(routeUid: string, userDetailsParam: any, showSuccessToast: boolean, statusCallback: (status: boolean) => void): void {
    this._dataCollectorService.postData(this.getAssignRouteUrl(routeUid), userDetailsParam)
      .subscribe((response: any) => {
        if (showSuccessToast) {
          this._toastService.success(response?.message);
        }
        statusCallback(true);
      }, (error: any) => {
        statusCallback(false);
      });
  }

  unAssignRoute(routeUid: string, userDetailsParam: any, showSuccessToast: boolean, statusCallback: (status: boolean) => void): void {
    this._dataCollectorService.postData(this.getUnassignRouteUrl(routeUid), userDetailsParam)
      .subscribe((response: any) => {
        if (showSuccessToast) {
          this._toastService.success(response?.message);
        }
        statusCallback(true);
      }, (error: any) => {
        statusCallback(false);
      });
  }

  reassignJobToAnotherRoute(routeUid: string, params: any, showSuccessToast: boolean, statusCallback: (status: boolean) => void): void {
    this._dataCollectorService.postData(this.getReassignRouteUrl(routeUid), params)
      .subscribe((response: any) => {
        if (showSuccessToast) {
          this._toastService.success(response?.message);
        }
        statusCallback(true);
      }, (error: any) => {
        statusCallback(false);
      });
  }

  assignRouteJob(routeUid: string, jobDetailsParam: any, statusCallback: (status: boolean) => void): void {
    this._dataCollectorService.postData(this.getUpdateRouteJobUrl(routeUid), jobDetailsParam)
      .subscribe((response: any) => {
        this._toastService.success(response?.message);
        statusCallback(true);
      }, (error: any) => {
        statusCallback(false);
      });
  }

  optimizeRoute(routeUid: string, statusCallback: (status: boolean) => void): void {
    const loader = this._toastService.loading(this._utilityService.getLocaleValue('loader.route_optimise'));
    this._dataCollectorService.postData(this.getRouteOptimizeUrl(routeUid), {})
      .subscribe((response: any) => {
        loader.close();
        if (response?.message) {
          this._toastService.success(response?.message);
        }
        statusCallback(true);
      },
        (error: any) => {
          loader.close();
          statusCallback(false);
        });
  }

  updateJobDetails(jobUid: any, payload: any, statusCallback: (status: boolean) => void): any {
    this._dataCollectorService.putData(this.getJobUpdateUrl(jobUid), payload)
      .subscribe((response: any) => {
        this._toastService.success(response?.message);
        statusCallback(true);
      }, (error: any) => {
        statusCallback(false);
      });
  }

  updateRouteLock(routeUid: string, isLocked: any, statusCallback: (status: boolean) => void): any {
    this._dataCollectorService.putData(this.getRouteLockUrl(routeUid, isLocked), null)
      .subscribe((response: any) => {
        this._toastService.success(response?.message);
        statusCallback(true);
      }, (error: any) => {
        statusCallback(false);
      });
  }

  clearScheduleJobFromRoute(jobDetails: any, statusCallback: (status: boolean) => void): void {

    // Make the API call to remove the job from the route
    const removeJobParam = {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      jobs: [{ job_uid: jobDetails?.job_uid, }], unassign_users: false
    };

    this.removeJobFromRoute(jobDetails?.route?.route_uid, removeJobParam, (status: true) => {
      if (status) {
        statusCallback(true);
      }
      else{
        statusCallback(false);
      }
    });
  }

  clearScheduleJob(jobDetails: any, statusCallback: (status: boolean) => void): void {
    // Check if job details contain route_uid
    if (jobDetails?.route?.route_uid) {
      const removeJobParam = {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        jobs: [{ job_uid: jobDetails?.job_uid, }], unassign_users: false
      };

      this.removeJobFromRoute(jobDetails?.route?.route_uid, removeJobParam, (status: true) => {
        if (status) {
          this.clearScheduleJobUpdate(jobDetails, statusCallback);
        }
      });
    } else {
        // If no route_uid, directly update the job details
        this.clearScheduleJobUpdate(jobDetails, statusCallback);
    }
  }

  clearScheduleJobUpdate(jobDetails: any, statusCallback: (status: boolean) => void): void {
      // Payload for updating the job details
      const payload: any = {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          job: { job_uid: jobDetails.job_uid, due_date: moment(jobDetails?.due_date)?.endOf('day')?.utc()?.format('YYYY-MM-DD HH:mm:ss') }
      };
      if(jobDetails?.job_timezone && this._utilityService.isTimeZoneEnabled === false){
        payload.job['job_timezone'] = null;
      }
      // Make the API call to clear the job schedule
      this._dataCollectorService.putData(`${this.jobDetailsUrl}?clear_schedule=true`, payload).subscribe(
          (response: any) => {
              this._toastService.success(response.message);
              statusCallback(true);
          },
          (error: any) => {
              statusCallback(false);
          }
      );
  }

  //Custom Employee details with jobs and timeoff using Local data
  getCustomEmployeeDetailsLocal(startDate: Moment, endDate: Moment, users: any, jobs: any, nonJobEvents?: any): any {
    const customUserDetails = {};
    const fromDate = moment.utc(startDate.clone().startOf('day').utc().format());
    const toDate = moment.utc(endDate.clone().endOf('day').utc().format());
    const _fromDate = fromDate.clone();
    const _toDate = toDate.clone();
    for (_fromDate; _fromDate.isSameOrBefore(_toDate, 'day'); _fromDate.add(1, 'day')) {
      let hasNonJobEvent: boolean = false;
      let hasJob: boolean = false;
      let userJobs = []; let userTimeOff = []; let shiftHours = []; let userNonJobEvents = [];
      users?.forEach((user: any) => {
        userJobs = [];
        userNonJobEvents = [];
        userTimeOff = [];
        shiftHours = [];
        const userUid = user?.user_uid;
        jobs?.forEach((job: any) => {
          const assignedTo: any[] = job?.assigned_to?.filter((assignee: any) => _.get(assignee, ['user', 'user_uid']) === userUid);
          hasJob = assignedTo?.length > 0;
          if (hasJob) {
            userJobs.push(job);
          }
        });
        nonJobEvents?.forEach((nonJobEvent: any) => {
          if (!nonJobEvent?.is_available) {
            const assignedTo: any[] = nonJobEvent?.assigned_to?.filter((assignee: any) => _.get(assignee, ['user', 'user_uid']) === userUid);
            hasNonJobEvent = assignedTo?.length > 0;
            if (hasNonJobEvent) {
              userNonJobEvents.push(nonJobEvent);
            }
          }
        });
        userTimeOff = user?.timeoff_request?.filter((timeOff: any) => this.isDateConflict(_fromDate.clone().startOf('day'), _fromDate.clone().endOf('day'), moment.utc(timeOff?.request_from), moment.utc(timeOff?.request_to)));
        shiftHours = user?.user_shifts?.filter((shift: any) => this.isDateConflict(_fromDate.clone().startOf('day'), _fromDate.clone().endOf('day'), moment.utc(shift?.start_date_time), moment.utc(shift?.end_date_time)));
        if (userJobs.length > 0 || userTimeOff.length > 0 || shiftHours.length > 0 || userNonJobEvents.length) {
          customUserDetails[`${_fromDate.format('YYYY-MM-DD')}_${userUid}`] = {
            jobs: userJobs,
            timeOff: userTimeOff,
            shiftHours: shiftHours,
            nonJobEvents: userNonJobEvents
          };
        }
      });
    }
    return customUserDetails;
  }

  //Custom Employee details with overlapping jobs and timeoff using /jobs/schedule/overlap API data
  getCustomEmployeeDetailsRemote(data: any[]): any {
    const customUserDetails: any = {};
    data?.forEach((customObj: any) => {
      if (customObj?.jobs.length > 0 || customObj?.timeoff?.length || customObj?.user_shifts?.length || customObj?.routes?.length || customObj?.non_job_events?.length) {
        customObj?.jobs?.forEach((job: any) => {
          const assignedUser: any[] = job?.assigned_to;
          assignedUser?.forEach((assignee: any) => {
            const assigneeUid = _.get(assignee, ['user', 'user_uid']);
            if (!this._utilityService.isEmptyOrUndefined(assigneeUid)) {
              if (!customUserDetails.hasOwnProperty(`${customObj?.date}_${assigneeUid}`)) {
                customUserDetails[`${customObj?.date}_${assigneeUid}`] = { jobs: [], timeOff: [], shiftHours: [], routes: [], nonJobEvents: [] };
              }
              customUserDetails[`${customObj?.date}_${assigneeUid}`].jobs.push(job);
            }
          });
        });

        customObj?.routes?.forEach((route: any) => {
          const assignedUser: any[] = route?.assigned_to;
          assignedUser?.forEach((assignee: any) => {
            const assigneeUid = _.get(assignee, ['user', 'user_uid']);
            if (!this._utilityService.isEmptyOrUndefined(assigneeUid)) {
              if (!customUserDetails.hasOwnProperty(`${customObj?.date}_${assigneeUid}`)) {
                customUserDetails[`${customObj?.date}_${assigneeUid}`] = { jobs: [], timeOff: [], shiftHours: [], routes: [], nonJobEvents: [] };
              }
              customUserDetails[`${customObj?.date}_${assigneeUid}`].jobs.push(route);
            }
          });
        });

        customObj?.timeoff?.forEach((_timeOff: any) => {
          const assignedUser = _.get(_timeOff, ['requested_by', 'user_uid']);
          if (!this._utilityService.isEmptyOrUndefined(assignedUser)) {
            if (!customUserDetails.hasOwnProperty(`${customObj?.date}_${assignedUser}`)) {
              customUserDetails[`${customObj?.date}_${assignedUser}`] = { jobs: [], timeOff: [], shiftHours: [], routes: [], nonJobEvents: [] };
            }
            customUserDetails[`${customObj?.date}_${assignedUser}`].timeOff.push(_timeOff);
          }
        });

        customObj?.non_job_events?.forEach((event: any) => {
          const assignedUser: any[] = event?.assigned_to;
          assignedUser?.forEach((assignee: any) => {
            const assigneeUid = _.get(assignee, ['user', 'user_uid']);
            if (!this._utilityService.isEmptyOrUndefined(assigneeUid)) {
              if (!customUserDetails.hasOwnProperty(`${customObj?.date}_${assigneeUid}`)) {
                customUserDetails[`${customObj?.date}_${assigneeUid}`] = { jobs: [], timeOff: [], shiftHours: [], routes: [], nonJobEvents: [] };
              }
              customUserDetails[`${customObj?.date}_${assigneeUid}`].nonJobEvents.push(event);
            }
          });
        });

        customObj?.user_shifts?.forEach((shifts: any) => {
          const userUid: string = shifts?.user_details?.user_uid;
          if (!this._utilityService.isEmptyOrUndefined(userUid)) {
            if (!customUserDetails.hasOwnProperty(`${customObj?.date}_${userUid}`)) {
              customUserDetails[`${customObj?.date}_${userUid}`] = { jobs: [], timeOff: [], shiftHours: [], routes: [], nonJobEvents: [] };
            }
            customUserDetails[`${customObj?.date}_${userUid}`].shiftHours.push(shifts);
          }
        });
      }
    });
    return customUserDetails;
  }

  updateJobEventsScheduleDateTime(eventRecords: any[], jobUid: any, schedulerStartTime: Moment, scheduledEndTime: Moment): any[] {
    let events: any[] = [...eventRecords];
    events = events.map((event: any) => {
      if (event?.job_uid === jobUid) {
        event.startDate = schedulerStartTime.format('YYYY-MM-DD HH:mm:ss');
        event.endDate = scheduledEndTime.format('YYYY-MM-DD HH:mm:ss');
        event.scheduled_start_time = schedulerStartTime.utc().format();
        event.scheduled_end_time = scheduledEndTime.utc().format();
      }
      return event;
    });
    return events;
  }

  updateNonJobEventDateTime(eventRecords: any[], jobUid: any, eventStartTime: Moment, eventEndTime: Moment): any[] {
    let events: any[] = [...eventRecords];
    events = events.map((event: any) => {
      if (event?.job_uid === jobUid) {
        event.startDate = eventStartTime.format('YYYY-MM-DD HH:mm:ss');
        event.endDate = eventEndTime.format('YYYY-MM-DD HH:mm:ss');
        event.start_time = eventStartTime.utc().format();
        event.end_time = eventEndTime.utc().format();
      }
      return event;
    });
    return events;
  }

  updateRouteEventDepartureDateTime(eventRecords: any[], routeUid: any, startDateTime: Moment, endDateTime: Moment): any[] {
    let events: any[] = _.cloneDeep(eventRecords);
    events = events.map((event: any) => {
      if (event?.route_uid === routeUid) {
        event.startDate = startDateTime.format('YYYY-MM-DD HH:mm:ss');
        event.endDate = endDateTime.format('YYYY-MM-DD HH:mm:ss');
        event.departure = startDateTime.utc().format();
        event.route_end_time = endDateTime.utc().format();
      }
      return event;
    });
    return events;
  }

  updateAssignmentRecords(allAssignments: any[], job: any): any[] {
    allAssignments = allAssignments.filter(assignment => assignment.id?.indexOf(job.job_uid + '_') === -1);
    const newAssignments = _.uniq(this.createJobAssignmentRecord(job));
    newAssignments?.forEach((assignment: any) => {
      allAssignments.push(assignment);
    });
    return allAssignments;
  }

  updateNonJobAssignmentRecords(allAssignments: any[], nonJobEVentDetails: any): any[] {
    allAssignments = allAssignments.filter(assignment => assignment.id?.indexOf(nonJobEVentDetails.event_uid + '_') === -1);
    const newAssignments = _.uniqBy(this.createNonJobAssignmentRecord(nonJobEVentDetails), 'id');
    newAssignments?.forEach((assignment: any) => {
      allAssignments.push(assignment);
    });
    return allAssignments;
  }

  removeAssignmentFromScheduler(assignmentRecords: any[], userUid: any, jobUid: any): any {
    let assignments: any[] = [...assignmentRecords];
    const id = `${jobUid}_${userUid}`;
    assignments = assignments.filter((event: any) => event.id !== id);
    return assignments;
  }

  createSchedulerJobEvent(jobDetails: any, startDateTime?: any, endDateTime?: any, timezone: string = this.selectedTimezone[this.activeDispatchTab]): any {
    const event = _.cloneDeep(jobDetails);
    event.id = event?.job_uid;
    event.detailsType = 'job';

    event.eventColor = '#3c763d';
    if (event.current_job_status && event?.current_job_status?.status_type === 'CLOSED') {
      event.resizable = false;
      event.draggable = false;
    }
    if (!this._utilityService.isEmptyOrUndefined(startDateTime) && !this._utilityService.isEmptyOrUndefined(endDateTime)) {
      event.startDate = startDateTime.tz(timezone).format('YYYY-MM-DD HH:mm:ss');
      event.endDate = endDateTime.tz(timezone).format('YYYY-MM-DD HH:mm:ss');
      event.scheduled_start_time = startDateTime.utc().format();
      event.scheduled_end_time = endDateTime.utc().format();
      event.timeZone = timezone;
    }
    else {
      event.startDate = moment(jobDetails.scheduled_start_time).tz(timezone).format('YYYY-MM-DD HH:mm:ss');
      event.endDate = moment(jobDetails.scheduled_end_time).tz(timezone).format('YYYY-MM-DD HH:mm:ss');
    }
    return event;
  }

  createSchedulerNonJobEvent(nonJobEventDetails: any, startDateTime?: any, endDateTime?: any, timezone: string = this.selectedTimezone[this.activeDispatchTab]): any {
    const event = _.cloneDeep(nonJobEventDetails);
    event.id = event?.event_uid;
    event.detailsType = 'non_job_event';

    event.eventColor = '#3c763d';
    event.resizable = false;
    event.draggable = false;
    if (!this._utilityService.isEmptyOrUndefined(startDateTime) && !this._utilityService.isEmptyOrUndefined(endDateTime)) {
      event.startDate = startDateTime.tz(timezone).format('YYYY-MM-DD HH:mm:ss');
      event.endDate = endDateTime.tz(timezone).format('YYYY-MM-DD HH:mm:ss');
      event.start_time = startDateTime.utc().format();
      event.end_time = endDateTime.utc().format();
      event.timeZone = timezone;
    }
    else {
      event.startDate = moment(nonJobEventDetails?.start_time).tz(timezone).format('YYYY-MM-DD HH:mm:ss');
      event.endDate = moment(nonJobEventDetails?.end_time).tz(timezone).format('YYYY-MM-DD HH:mm:ss');
    }
    return event;
  }

  createSchedulerRouteEvent(routeDetails: any, startDateTime: Moment, endDateTime: Moment): any {
    const event = _.cloneDeep(routeDetails);
    event.id = event?.route_uid;
    event.detailsType = 'route';
    event.manuallyScheduled = true;
    event.durationUnit = 'hour';
    event.children = [];
    if (!this._utilityService.isEmptyOrUndefined(startDateTime) && !this._utilityService.isEmptyOrUndefined(endDateTime)) {
      event.startDate = startDateTime.format('YYYY-MM-DD HH:mm:ss');
      event.endDate = endDateTime.format('YYYY-MM-DD HH:mm:ss');
      event.departure = startDateTime.utc().format();
      event.route_end_time = endDateTime.utc().format();
    }
    else {
      event.startDate = moment(event.departure).format('YYYY-MM-DD HH:mm');
      event.endDate = moment(event.route_end_time).format('YYYY-MM-DD HH:mm');
    }
    return event;
  }

  createJobAssignmentRecord(jobDetails: any): any {
    const schedulerAssignments: any[] = [];
    const assignedTo: any[] = jobDetails?.assigned_to;
    assignedTo.forEach((assignee: any) => {
      const assignmentRecord = {
        id: jobDetails?.job_uid + '_' + assignee?.user.user_uid,
        eventId: jobDetails.job_uid,
        resourceId: assignee?.user.user_uid
      };
      schedulerAssignments.push(assignmentRecord);
    });
    return schedulerAssignments;
  }

  createNonJobAssignmentRecord(nonJobEventDetails: any): any {
    const schedulerAssignments: any[] = [];
    const assignedTo: any[] = nonJobEventDetails?.assigned_to;
    assignedTo.forEach((assignee: any) => {
      const assignmentRecord = {
        id: nonJobEventDetails?.event_uid + '_' + assignee?.user.user_uid,
        eventId: nonJobEventDetails?.event_uid,
        resourceId: assignee?.user.user_uid
      };
      schedulerAssignments.push(assignmentRecord);
    });
    return schedulerAssignments;
  }

  createRouteAssignmentRecord(routeDetails: any): any {
    const schedulerAssignments: any[] = [];
    const assignedTo: any[] = routeDetails?.assigned_to;
    assignedTo.forEach((assignee: any) => {
      const assignmentRecord = {
        id: routeDetails?.route_uid + '_' + assignee?.user.user_uid,
        eventId: routeDetails.route_uid,
        resourceId: assignee?.user.user_uid
      };
      schedulerAssignments.push(assignmentRecord);
    });
    return schedulerAssignments;
  }

  scheduleConfirmationDialog(type: 'job' | 'route', eventDetails: any, warnings: any): any {
    let title: string = '';
    let message: string = '';
    if(type === 'job') {
      const prefix = _.get(eventDetails, 'prefix') || '';
      const workOrderNumber = _.get(eventDetails, 'work_order_number') || '';
      const jobTitle = _.get(eventDetails, 'job_title') || '';
      title = `${this._utilityService.getLocaleValue('dispatchBoard.scheduler.reschedule.dialog.dispatch_job', 'Dispatch Job')} '${this.getJobTitle(prefix, workOrderNumber, jobTitle)}'`;
      message = `${this.formatScheduleWarnings(warnings)} <br> ${this._utilityService.getLocaleValue('"dispatchBoard.scheduler.reschedule.warnings.confirmation', 'Are you sure to assign this job ?')}`;
    }
    else if (type === 'route') {
      const routeName = eventDetails?.route_name;
      title = `${this._utilityService.getLocaleValue('dispatchBoard.scheduler.reschedule.dialog.dispatch_route', 'Dispatch Route')} '${routeName}'`;
      message = `${this.formatScheduleWarnings(warnings)} <p> ${this._utilityService.getLocaleValue('"dispatchBoard.scheduler.reschedule_route.warnings.confirmation', 'Are you sure to assign this route ?')}</p>`;
    }

    const scheduleConfirmationDialog = this._zuperDialogService.open({
      title: title,
      type: 'error',
      message: `<div class="space-y-2 mt-2">${message}</div>`,
      actions: {
        confirm: {
          show: true,
          label: 'Yes',
          color: 'primary',
          confirmDisplayKey: 'yes',
        },
        cancel: {
          show: true,
          label: 'No',
          cancelDisplayKey: 'no'
        }
      },
      dismissible: false,
      extraClass: 'w-5/12'
    });
    return scheduleConfirmationDialog;
  }

  jobDetailsChangeConfirmationDialog(jobDetails: any, type: 'unassign' | 'delete' | 'clearSchedule', optionalData?: any): MatDialogRef<any> {
    const prefix = _.get(jobDetails, 'prefix') || '';
    const workOrderNumber = _.get(jobDetails, 'work_order_number') || '';
    const jobTitle = _.get(jobDetails, 'job_title') || '';
    const jobIdTitle = this.getJobTitle(prefix, workOrderNumber, jobTitle);
    let dialogTitle: string; let dialogMessage: string;
    let confirmLabel: string; let confirmDisplayKey: string;
    let color: string = 'primary';

    if (type === 'delete') {
      dialogTitle = this._utilityService.getLocaleValue('text.delete_job', 'Delete Job');
      dialogMessage = `${this._utilityService.getLocaleValue('delete.job.confirmation.message')} <span class="text-gray-900 font-medium">
      '${jobIdTitle}'</span> ?`;
      confirmLabel = 'Delete';
      confirmDisplayKey = 'delete.text';
      color = 'error';
    }
    else if (type === 'unassign') {
      const userName = optionalData?.userName || '';
      dialogTitle = this._utilityService.getLocaleValue('text.unassign_job', 'Unassign Job');
      dialogMessage = `${this._utilityService.getLocaleValue('dispatchBoard.scheduler.dialog.unassign.message')} <span class="text-gray-900 font-medium">
      ${userName} </span> from <span class="text-gray-900 font-medium">'${jobIdTitle}'</span> ?`;
      confirmLabel = 'Unassign';
      confirmDisplayKey = 'text.unassign';
    }
    else if (type === 'clearSchedule') {
      dialogTitle = this._utilityService.getLocaleValue('text.clear_schedule', 'Clear Schedule');
      dialogMessage = this.getMessageWithNote(jobDetails);
      confirmLabel = 'Update';
      confirmDisplayKey = 'text.clear_schedule';
    }

    const confirmationDialog = this._zuperDialogService.open({
      title: dialogTitle,
      type: 'error',
      message: dialogMessage,
      actions: {
        confirm: {
          show: true,
          label: confirmLabel,
          color: color,
          confirmDisplayKey: confirmDisplayKey,
        },
        cancel: {
          show: true,
          label: 'Cancel',
          cancelDisplayKey: 'dispatchBoard.scheduler.dialog.delete.cancel'
        }
      },
      dismissible: false,
      extraClass: 'job-delete-dialog'
    });
    return confirmationDialog;
  }

  nonJobEventDetailsChangeConfirmationDialog(nonJobEventDetails: any, type: 'unassign' | 'delete', optionalData?: any): MatDialogRef<any> {
    let dialogTitle: string; let dialogMessage: string;
    let confirmLabel: string; let confirmDisplayKey: string;
    let color: string = 'primary';
    const eventName: string = nonJobEventDetails?.event_name;

    if (type === 'delete') {
      dialogTitle = this._utilityService.getLocaleValue('non_job_event.delete.title', 'Delete Non Job Event');
      dialogMessage = `${this._utilityService.getLocaleValue('non_job_event.delete.confirmation_message', 'Are you sure to delete the non job event')} <span class='font-medium text-gray-900 text-break'>${nonJobEventDetails?.event_name}</span> ?`;
      confirmLabel = 'Delete';
      confirmDisplayKey = 'delete.text';
      color = 'error';
    }
    else if (type === 'unassign') {
      const userName = optionalData?.userName || '';
      dialogTitle = this._utilityService.getLocaleValue('text.unassign_non_job_event', 'Unassign Non Job Event');
      dialogMessage = `${this._utilityService.getLocaleValue('dispatchBoard.scheduler.dialog.unassign.message')} <span class="text-gray-900 font-medium text-break">
      ${userName} </span> from <span class="text-gray-900 font-medium">${eventName}</span> ?`;
      confirmLabel = 'Unassign';
      confirmDisplayKey = 'text.unassign';
    }

    const confirmationDialog = this._zuperDialogService.open({
      title: dialogTitle,
      type: 'error',
      message: dialogMessage,
      actions: {
        confirm: {
          show: true,
          label: confirmLabel,
          color: color,
          confirmDisplayKey: confirmDisplayKey,
        },
        cancel: {
          show: true,
          label: 'Cancel',
          cancelDisplayKey: 'dispatchBoard.scheduler.dialog.delete.cancel'
        }
      },
      dismissible: false,
      extraClass: 'non-job-delete-dialog'
    });
    return confirmationDialog;
  }
  
  routeDetailsChangeConfirmationDialog(routeDetails: any, type: 'deleteRoute' | 'unassignRoute' | 'lockRoute' | 'unlockRoute' | 'removeJob', optionalData?: any): MatDialogRef<any> {
    let dialogTitle: string;
    let dialogMessage: string;
    let confirmLabel: string;
    let color: string;
    let confirmDisplayKey: string;
    let routeName = routeDetails?.route_name;
    const departure = moment.utc(routeDetails?.departure).tz(this.selectedTimezone[this.activeDispatchTab]).format(this.dateTimeFormat);
    if (type === 'deleteRoute') {
      dialogTitle = this._utilityService.getLocaleValue('text.delete_route', 'Delete Route');
      dialogMessage = `${this._utilityService.getLocaleValue('route.delete.confirmation_message')} <span class="text-gray-900 font-medium">
      ${routeName} (${departure}) </span> ?`;
      confirmLabel = 'Delete Route';
      confirmDisplayKey = 'text.delete_route';
      color = 'error';
    }
    else if (type === 'unassignRoute') {
      if (optionalData?.userDetails) {
        const userDetails = optionalData?.userDetails;
        const userName = this._utilityService.concatTwoStrings(userDetails?.first_name, userDetails?.last_name);
        dialogTitle = this._utilityService.getLocaleValue('dispatchBoard.scheduler.route.event_menu.options.unassign_route', 'Unassign Route');
        dialogMessage = `${this._utilityService.getLocaleValue('dispatchBoard.scheduler.dialog.unassign.message')} <span class="text-gray-900 font-medium">
        ${userName} </span> from <span class="text-gray-900 font-medium">'${routeName}'</span> ?`;
        confirmLabel = 'Unassign';
        confirmDisplayKey = 'text.unassign';
        color = 'error';
      }
    }
    else if (type === 'lockRoute') {
      dialogTitle = this._utilityService.getLocaleValue('text.lock_route', 'Lock Route');
      dialogMessage = `${this._utilityService.getLocaleValue('dispatchBoard.scheduler.route.lock_confirmation.dialog_message')} <span class="text-gray-900 font-medium">
      ${routeName} (${departure}) </span> ?<br><br><div class='flex gap-2'><i class='ti ti-exclamation-circle text-3xl'></i><span class='font-normal'>${this._utilityService.getLocaleValue('dispatchBoard.scheduler.route.lock_confirmation.dialog_alert')}</span></div>`;
      confirmLabel = 'Lock Route';
      confirmDisplayKey = 'text.lock_route';
      color = 'error';
    }
    else if (type === 'unlockRoute') {
      dialogTitle = this._utilityService.getLocaleValue('text.unlock_route', 'Unlock Route');
      dialogMessage = `${this._utilityService.getLocaleValue('dispatchBoard.scheduler.route.unlock_confirmation.dialog_message')} <span class="text-gray-900 font-medium">
      ${routeName} (${departure}) </span> ?`;
      confirmLabel = 'Unlock Route';
      confirmDisplayKey = 'text.unlock_route';
      color = 'error';
    }
    else if (type === 'removeJob') {
      const jobDetails: any = optionalData?.jobDetails;
      if (jobDetails) {
        const jobTitle = this.getJobTitle(jobDetails?.prefix, jobDetails?.work_order_number, jobDetails?.job_title);
        dialogTitle = this._utilityService.getLocaleValue('alert.remove_job_from_route', 'Remove Job from Route');
        dialogMessage = `${this._utilityService.getLocaleValue('fee.remove.text.message', 'Are you sure to remove')} <span class="text-gray-900 font-medium">
        ${jobTitle} </span> from <span class="text-gray-900 font-medium">${routeName} (${departure}) </span> ?`;
        if (optionalData?.type === 'recurringRoute') {
          routeName = routeDetails?.recurring_route_name;
          dialogMessage = `${this._utilityService.getLocaleValue('fee.remove.text.message', 'Are you sure to remove')} <span class="text-gray-900 font-medium">
        ${jobTitle} </span> from all instances of <span class="text-gray-900 font-medium">${routeName} </span> ?`;
        }
        confirmLabel = 'Remove Job';
        confirmDisplayKey = 'alert.confirm.remove_job';
        color = 'error';
      }
    }
    const confirmationDialog = this._zuperDialogService.open({
      title: dialogTitle,
      type: 'error',
      message: dialogMessage,
      actions: {
        confirm: {
          show: true,
          label: confirmLabel,
          color: color,
          confirmDisplayKey: confirmDisplayKey,
        },
        cancel: {
          show: true,
          label: 'Cancel',
          cancelDisplayKey: 'dispatchBoard.scheduler.dialog.delete.cancel'
        }
      },
      dismissible: false,
      extraClass: 'job-delete-dialog'
    });
    return confirmationDialog;
  }

  timeoffListBuilder(timeOffs: any): any {
    const tz = this.selectedTimezone[this.activeDispatchTab];
    const start = moment.utc(timeOffs?.request_from).tz(tz);
    const end = moment.utc(timeOffs?.request_to).tz(tz);
    const totalDays = end.clone().endOf('day').diff(start.clone().startOf('day'), 'days') + 1;
    let returnData: any = [];
  
    for (let i = 0; i < totalDays; i++) {
      const dayStart = start.clone().startOf('day').add(i, 'days');
      const dayEnd = dayStart.clone().endOf('day');
      let chunkStart = dayStart;
      let chunkEnd = dayEnd;
  
      if (i === 0) chunkStart = start;
      if (i === totalDays - 1) chunkEnd = end;
  
      if (!this.checkExemptDate(dayStart, timeOffs?.exempt_dates)) {
        returnData.push({
          ...timeOffs,
          request_from: chunkStart.format('YYYY-MM-DD HH:mm:ss'),
          request_to: chunkEnd.format('YYYY-MM-DD HH:mm:ss'),
          actualRequestFrom: timeOffs?.request_from,
          actualRequestTo: timeOffs?.request_to
        });
      }
    }
    return returnData;
  }

  checkExemptDate(date: Moment, exemptDates: any[]): boolean {
    let isExemptDate: boolean = false;
    exemptDates.forEach((exemptDate: any) => {
      const excludeDate = moment.utc(exemptDate, 'YYYY-MM-DD HH:mm:ss').tz(this.selectedTimezone[this.activeDispatchTab]);
      if (excludeDate.isSame(date, 'd')) {
        isExemptDate = true;
      }
    });
    return isExemptDate;
  }

  setMultiModulePickerTabs(jobId: any): void {
    const tabs: Array<TabsData> = [
      {
        'displayName': 'Customer',
        'displayKey': 'customer',
        'dataKey': 'CUSTOMER',
        'module': 'CUSTOMER',
        'dataUrl': '/customers'
      },
      {
        'displayName': 'Organization',
        'displayKey': 'text.organization',
        'dataKey': 'ORGANIZATION',
        'module': 'ORGANIZATION',
        'dataUrl': '/organization'
      },
      {
        'displayName': 'Property',
        'displayKey': 'text.property',
        'dataKey': 'PROPERTY',
        'module': 'PROPERTY',
        'dataUrl': '/property'
      },
      {
        'displayName': 'Quotes',
        'displayKey': 'text.quotes',
        'dataKey': 'ESTIMATES',
        'module': 'ESTIMATES',
        'dataUrl': '/estimate'
      },
      {
        'displayName': 'Contract',
        'displayKey': 'contract',
        'dataKey': 'SERVICE_CONTRACTS',
        'module': 'SERVICE_CONTRACTS',
        'dataUrl': '/service_contract'
      },
      {
        'displayName': 'ASSETS',
        'displayKey': 'asset.text',
        'dataKey': 'ASSETS',
        'module': 'ASSETS',
        'dataUrl': '/assets'
      }
    ];
    this._multiModulePickerService.setTabs(tabs);
  }

  createNewNote(value: any): void {
    const payLoad: any = {
      note: {
        attachments: value.attachments && value.attachments.length > 0 ? value.attachments.filter((data: any) => !!data) : [],
        note: value.note,
        job: value.jobUid,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        user_mentions: this.validateMentions(value.note), is_private: value.isPrivate, visible_to_customer: value.visibleToCustomer, visible_to_fe: value.isBackOfficeVisible
      },
    };
    if (!_.isEmpty(value.associatedModules)) {
      _.each(_.keys(value.associatedModules), (module: string) => {
        if (module) {
          payLoad.note[ParamKey[module.toUpperCase()]] = value.associatedModules[module]?.length > 0 ? value.associatedModules[module][0][ModuleUidKey[module.toUpperCase()]] : null;
        }
      });
    }
    this._dataCollectorService.postData(this._notesService.notesUrl, payLoad)
      .subscribe(
        (response: any) => {
          this._toastService.success(response.message);
        });
  }

  validateMentions(noteValue: string): string[] {
    const regex = new RegExp('<a.*?href=.*?\/employees\/([A-Fa-f0-9]{8}-[A-Fa-f0-9]{4}-[A-Fa-f0-9]{4}-[A-Fa-f0-9]{4}-[A-Fa-f0-9]{12})\/details.*?>', 'g');
    const userMentionsId: string[] = [];
    let matches: any[] = [];
    // eslint-disable-next-line no-cond-assign
    while (matches = regex.exec(noteValue)) {
      userMentionsId.push(matches[1]);
    }
    return userMentionsId;
  }

  getUserJobCount(jobs: any[], userUid: any): number {
    let jobCount = 0;
    jobs.forEach((job: any) => {
      const assignedTo = job?.assigned_to;
      // eslint-disable-next-line @typescript-eslint/naming-convention
      const isJobAssignedToUser = _.filter(assignedTo, { user: { user_uid: userUid } }).length > 0;
      if (isJobAssignedToUser) {
        jobCount += 1;
      }
    });
    return jobCount;
  }

  getStartEndTime(startDateTime: any, endDateTime: any, isUTC: boolean, format?: string, onlyTime: boolean = false, showEndDate: boolean = false, timezone = this.selectedTimezone[this.activeDispatchTab]): any[] {
    let startDate: any;
    let endDate: any;
    if (!startDateTime || !endDateTime) { return [null, null]; }
    if (format) {
      startDateTime = isUTC ? dayjs.utc(startDateTime, format).tz(timezone) : dayjs(startDateTime, format).tz(timezone);
      endDateTime = isUTC ? dayjs.utc(endDateTime, format).tz(timezone) : dayjs(endDateTime, format).tz(timezone);
    }
    else {
      startDateTime = isUTC ? dayjs.utc(startDateTime).tz(timezone) : dayjs(startDateTime).tz(timezone);
      endDateTime = isUTC ? dayjs.utc(endDateTime).tz(timezone) : dayjs(endDateTime).tz(timezone);
    }

    const customFormat = onlyTime ? this.timeFormat : this.dateTimeFormat;
    if (startDateTime.tz(timezone).isSame(endDateTime.tz(timezone), 'date')) {
      startDate = dayjs(startDateTime).utc().tz(timezone).format(customFormat);
      endDate = endDateTime.tz(timezone).format(this.timeFormat);
    }
    else {
      startDate = dayjs(startDateTime).utc().tz(timezone).format(customFormat);
      if (showEndDate) {
        endDate = dayjs(endDateTime).utc().tz(timezone).format(this.dateTimeFormat);
      }
      else {
        endDate = dayjs(endDateTime).utc().tz(timezone).format(customFormat);
      }
    }
    return [startDate, endDate];
  }

  formatDateTime(dateTime: any, format: string = this.dateTimeFormat, skipTimeZone: boolean = false): string {
    return skipTimeZone ? dayjs(dateTime).format(format) : dayjs(dateTime).tz(this.selectedTimezone[this.activeDispatchTab]).format(format);
  }

  formatStartEndTime(startDateTime: string | Moment, endDateTime: string | Moment, timezone: string = moment.tz.guess()): any[] {
    startDateTime = moment(startDateTime);
    endDateTime = moment(endDateTime);
    const isSameDate = startDateTime.isSame(endDateTime, 'date');
    const startDate: any = startDateTime.tz(timezone).format(this.dateTimeFormat);;
    const endDate = endDateTime.tz(timezone).format(isSameDate ? this.timeFormat : this.dateTimeFormat);
    return [startDate, endDate];
  }

  getAssignedNameAndCount(assignedTo: any[]): string {
    let formattedAssignedTo = '';
    const totalAssignedCount = assignedTo.length || 0;
    if (totalAssignedCount > 0) {
      const firstName = _.get(assignedTo[0], ['user', 'first_name']);
      const lastName = _.get(assignedTo[0], ['user', 'last_name']);
      formattedAssignedTo += this._utilityService.concatTwoStrings(firstName, lastName);
      formattedAssignedTo += `${totalAssignedCount > 1 ? ` + ${totalAssignedCount - 1} ${this._utilityService.getLocaleValue('text.more', 'more')}` : ''}`;
    }
    return formattedAssignedTo;
  }

  //Scheduler Timeoff
  setResourceTimeoff(schedulerInstance: any, schedulerEmployees: any): void {
    if (!schedulerInstance) { return; }
    schedulerEmployees?.forEach((user: any) => {
      const timeOffRequests: any[] = [];
      user?.timeoff_request.forEach((timeoff: any) => {
        const timeoffChunks = this.timeoffListBuilder(timeoff);
        timeoffChunks?.forEach((timeoffChunk: any) => {
          timeOffRequests.push(timeoffChunk);
        });
      });
      this.injectSchedulerTimeoff(schedulerInstance, schedulerEmployees, timeOffRequests, user);
    });
  }

  injectSchedulerTimeoff(schedulerInstance: any, schedulerEmployees: any, timeOffRequests: any, user: any, idPrefix?: any): any {
    if (!schedulerInstance) { return; }
    if (timeOffRequests?.length > 0) {
      this.suspendAllSchedulerEvents(schedulerInstance, { resourceTimeRange: true });
      const newResourceTimeRanges: any[] = [];
      timeOffRequests?.forEach((timeoff: any, index: number) => {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const userRole = _.find(schedulerEmployees, { user_uid: user.user_uid }).role_name;
        let prefix = index.toString();
        if (!this._utilityService.isEmptyOrUndefined(idPrefix)) {
          prefix = idPrefix.toString() + index.toString();
        }
        let reason = timeoff?.request_reason || '';
        let reasonUid = timeoff?.request_reason || '';
        if (reason === 'CUSTOM' && timeoff?.timeoff_request_type?.name) {
          reason = timeoff?.timeoff_request_type.name || '';
          reasonUid = timeoff?.timeoff_request_type?.timeoff_request_type_uid;
        }

        const resourceTimeOff: any = {
          id: 'timeoff_' + prefix.toString() + user?.user_uid,
          resourceId: user?.user_uid,
          requestUid: timeoff?.request_uid,
          startDate: timeoff?.request_from,
          endDate: timeoff?.request_to,
          remarks: timeoff?.request_remarks,
          status: timeoff?.approval_status,
          role: userRole,
          reason: reason,
          reasonUid: reasonUid,
          actualRequestFrom: timeoff.actualRequestFrom,
          actualRequestTo: timeoff.actualRequestTo,
          requestedBy: timeoff.requested_by,
          name: this.getTimeoffName(timeoff),
          resourceDetails: user,
          style: 'margin: auto; justify-content: center',
          timeRangeColor: 'red',
          cls: 'top-dashed timeoff',
          timeZone: this.selectedTimezone[this.activeDispatchTab],
          // eslint-disable-next-line @typescript-eslint/naming-convention
          no_of_days: timeoff?.no_of_days,
        };
        newResourceTimeRanges.push(resourceTimeOff);
      });
      schedulerInstance.resourceTimeRangeStore.add(newResourceTimeRanges);
      schedulerInstance.timeAxis.refreshData();
      schedulerInstance.resourceTimeRangeStore.refreshData();
      this.resumeAllSchedulerEvents(schedulerInstance, { resourceTimeRange: true });
    }
  }

  removeTimeoffFromScheduler(schedulerInstance: any, requestUid: string): void {
    if(schedulerInstance && requestUid) {
      const searchResults: any[] = schedulerInstance.resourceTimeRangeStore.search(requestUid, ['requestUid']);
      if(searchResults && searchResults.length) {
        this.suspendAllSchedulerEvents(schedulerInstance);
        searchResults.forEach((deletedEvent: any) => {
          schedulerInstance.resourceTimeRangeStore.remove(deletedEvent?.data);
        });
        this.resumeAllSchedulerEvents(schedulerInstance);
      }
    }
  }

  getUserTimeoffCount(schedulerInstance: any, userUid: any): number {
    if (schedulerInstance && !schedulerInstance?.isDestroyed) {
      let count = 0;
      const allTimeoffs = schedulerInstance.resourceTimeRangeStore.allRecords;
      count = allTimeoffs.filter((timeoff: any) => timeoff.data.resourceId === userUid).length;
      return count;
    }
  }

  editTimeOffEvent(schedulerInstance: any, timeoffDetails: any, schedulerEmployees: any, allTeams: any, selectedTeam: any, selectedTimezone: any, timeoffEditSuccess: (status: boolean, userUid: string, timeoff: any) => void): void {
    const userUid = timeoffDetails?.resourceId;
    /* eslint-disable @typescript-eslint/naming-convention */
    const userDetails = _.find(schedulerEmployees, { 'user_uid': userUid });
    const teamDetails = _.find(allTeams, { 'team_uid': selectedTeam });
    const user = {
      first_name: userDetails?.first_name, last_name: userDetails?.last_name, user_uid: userDetails?.user_uid, email: userDetails?.email
    };
    const team = {
      team_name: teamDetails?.team_name, team_uid: selectedTeam
    };
    const startDateTime = moment(timeoffDetails?.actualRequestFrom).tz(this.selectedTimezone[this.activeDispatchTab]);
    const endDateTime = moment(timeoffDetails?.actualRequestTo).tz(this.selectedTimezone[this.activeDispatchTab]);
    const timeoffData = { startDate: startDateTime, startTime: startDateTime.format('HH:mm:ss'), endDate: endDateTime, endTime: endDateTime.format('HH:mm:ss'), user: user, team: team, timezone: selectedTimezone, reason: timeoffDetails.reason, reasonUid: timeoffDetails.reasonUid, remarks: timeoffDetails.remarks, request_uid: timeoffDetails.requestUid };
    const editTimeoffDialogInstance = this._zuperDialogService.openCustom(NewTimeOffComponent,
      { disableClose: true, extraClass: 'new-timeoff', timeoffData: timeoffData, action: 'edit' }
    );

    editTimeoffDialogInstance.afterClosed()
    .subscribe((result: any) => {
      if (result.status) {
        this.removeTimeoffFromScheduler(schedulerInstance, timeoffDetails.requestUid);
        const requestUid = result.request_uid;
        const timeoffRequestUrl = `${this.timeoffDetailsUrl}/${requestUid}`;
        this._dataCollectorService.getData(timeoffRequestUrl)
          .subscribe((response) => {
            const timeoff = response?.data;
            const requestedBy = timeoff.requested_by;
            const _userUid = requestedBy.user_uid;
            timeoffEditSuccess(true, _userUid, timeoff);
            if (!this._utilityService.isEmptyOrUndefined(timeoff)) {
              const idPrefix = this.getUserTimeoffCount(schedulerInstance, _userUid);
              const timeoffChunks = this.timeoffListBuilder(timeoff);
              const timeOffRequests = [...timeoffChunks];
              this.injectSchedulerTimeoff(schedulerInstance, schedulerEmployees, timeOffRequests, requestedBy, idPrefix);
            }
          });
      }
    });
    /* eslint-enable @typescript-eslint/naming-convention */
  }

  deleteTimeOffEvent(schedulerInstance: any, timeoffDetails: any, deleteConfirmationCallBack: (status: boolean) => void): void {
    const [timeoffStartDate, timeoffEndDate] = this.getStartEndTime(timeoffDetails.actualRequestFrom, timeoffDetails.actualRequestTo, true);
    const resourceName = this._utilityService.concatTwoStrings(timeoffDetails.resourceDetails?.first_name, timeoffDetails.resourceDetails?.last_name);
    const timeoffDetailMessage = `${resourceName} (${timeoffStartDate} to ${timeoffEndDate})`;
    const deleteConfirmationMessage = `${this._utilityService.getLocaleValue('timeoff.delete.message.prefix')} ${this._utilityService.getLocaleValue('timeoff.delete.message.suffix')} - ${timeoffDetailMessage} ?`;
    const deleteConfirmationDialogRef = this._zuperDialogService.open({
      title: `${this._utilityService.getLocaleValue('timeoff.delete.dialog.title', 'Delete timeoff request')}`,
      message: deleteConfirmationMessage,
      type: 'error',
      actions: {
        confirm: {
          show: true,
          label: 'Ok',
          color: 'error',
          confirmDisplayKey: 'delete.text',
        },
        cancel: {
          show: true,
          label: 'Cancel'
        }
      },
      extraClass: 'timeoff-delete-dialog'
    });
    deleteConfirmationDialogRef.afterClosed()
      .subscribe((result: boolean) => {
        if (result) {
          const timeoffRequestUid = timeoffDetails?.requestUid;
          const timeoffDeleteUrl = `${this._dataCollectorService.baseurl()}/timesheets/request/timeoff/${timeoffRequestUid}`;
          const updatingTimeoffToastRef = this._toastService.loading(this._utilityService.getLocaleValue('timeoff.update.timeoff.requests.label'));
          this._dataCollectorService.deleteData(timeoffDeleteUrl).subscribe((response: any) => {
            updatingTimeoffToastRef.close();
            this._toastService.success(response.message);
            this.removeTimeoffFromScheduler(schedulerInstance, timeoffRequestUid);
            deleteConfirmationCallBack(true);
          },
            (error: any) => {
              updatingTimeoffToastRef.close();
              deleteConfirmationCallBack(false);
            });
        }
      });
  }

  getTimeoffName(timeoff: any): string {
    let reason = timeoff?.request_reason || timeoff?.reason || '';
    const singleDayLeave = moment(timeoff.actualRequestFrom).tz(this.selectedTimezone[this.activeDispatchTab]).format(this.dateFormat) === moment(timeoff.actualRequestTo).tz(this.selectedTimezone[this.activeDispatchTab]).format(this.dateFormat);
    const [timeoffStartDate, timeoffEndDate] = this.getStartEndTime(timeoff.actualRequestFrom, timeoff.actualRequestTo, true);
    if (reason === 'CUSTOM' && timeoff?.timeoff_request_type?.name) {
      reason = timeoff?.timeoff_request_type.name || '';
    }
    let timeoffName = `${this.titlecasePipe.transform(reason)} (${timeoffStartDate} -  ${timeoffEndDate})`;
    if (timeoff.all_day) {
      timeoffName = `${this.titlecasePipe.transform(reason)}`;
    }
    else if (!singleDayLeave) {
      timeoffName = `${this.titlecasePipe.transform(reason)} (${timeoffStartDate} -  ${timeoffEndDate})`;
    }

    if (timeoff?.no_of_days > 0) {
      if(timeoff?.no_of_days < 1) {
        timeoffName += ' - ' + this.getTimeDiff(moment.utc(timeoff.actualRequestFrom), moment.utc(timeoff.actualRequestTo),'hours', 1) + 'h';
      }
      else {
        timeoffName += ' - ' + timeoff?.no_of_days + 'd';
      }
    }
    return timeoffName;
  }

  updateSchedulerTimeoffTimezone(schedulerInstance: any): void {
    if(schedulerInstance) {
      this.suspendAllSchedulerEvents(schedulerInstance, { resourceTimeRange: true });
      const oldSchedulerTimeoff: any[] = schedulerInstance.resourceTimeRangeStore.allRecords.filter((resourceTimeRange: any) => resourceTimeRange?.id.startsWith('timeoff_'));
      oldSchedulerTimeoff.forEach((timeoffDetails: any) => {
        timeoffDetails.set({ name: this.getTimeoffName(timeoffDetails) });
      });
      this.resumeAllSchedulerEvents(schedulerInstance, { resourceTimeRange: true });
    }
  }

  //Employee shift
  setResourceShift(schedulerInstance: any, schedulerEmployees: any, currentView: 'DAY' | 'WEEK' | 'MONTH'): void {
    if (schedulerInstance && !schedulerInstance?.isDestroyed) {
      if (currentView === 'DAY') {
        schedulerEmployees.forEach((user: any) => {
          const userUid = user.user_uid;
          const userShifts: any[] = user?.user_shifts || [];
          if (userShifts.length > 0) {
            const customShiftDetails = { shiftStartTimes: [], shiftEndTimes: [], shiftLabels: [] };
            userShifts.forEach((userShift: any) => {
              customShiftDetails.shiftStartTimes.push(dayjs.utc(userShift.start_date_time).tz(this.selectedTimezone[this.activeDispatchTab]));
              customShiftDetails.shiftEndTimes.push(dayjs.utc(userShift.end_date_time).tz(this.selectedTimezone[this.activeDispatchTab]));
              customShiftDetails.shiftLabels.push(userShift.shift_label);
            });

            let previousShiftDetails: [string, Dayjs, Dayjs];
            const shiftDetails = _.zip(customShiftDetails.shiftLabels, customShiftDetails.shiftStartTimes, customShiftDetails.shiftEndTimes);
            shiftDetails.sort((one: any, two: any) => one[1].diff(two[1]));
            shiftDetails.forEach((shiftDetail: [string, Dayjs, Dayjs], index) => {
              if (index === 0 && shiftDetails.length !== 1) {
                const isShiftOnStartOfTheDay = shiftDetail[1].isSame(shiftDetail[1].startOf('day'));
                this.nonWorkingStartTime = isShiftOnStartOfTheDay ? null : this.getStartEndOf(shiftDetail[1], 'startOf', 'day');
                this.nonWorkingEndTime = shiftDetail[1].clone();
                this.setEmployeeShiftObject(userUid, shiftDetails);
              }

              if (previousShiftDetails) {
                const isPrevAndCurrShiftSameDate = previousShiftDetails[2].isSame(shiftDetail[1], 'date');
                if (isPrevAndCurrShiftSameDate) {
                  this.nonWorkingStartTime = previousShiftDetails[2].clone();
                  this.nonWorkingEndTime = shiftDetail[1].clone();
                }
                else {
                  const isPrevAndCurrConsecutiveDay = previousShiftDetails[2].clone().add(1, 'day').isSame(shiftDetail[1], 'date');
                  if (isPrevAndCurrConsecutiveDay) {
                    this.nonWorkingStartTime = previousShiftDetails[2].clone();
                    this.nonWorkingEndTime = shiftDetail[1].clone();
                  }
                  else {
                    this.nonWorkingStartTime = previousShiftDetails[2].clone();
                    const isShiftOnEndOfTheDay = previousShiftDetails[2].isSame(previousShiftDetails[2].endOf('day'));
                    this.nonWorkingEndTime = isShiftOnEndOfTheDay ? null : this.getStartEndOf(previousShiftDetails[2], 'endOf', 'day');
                  }
                }
                this.setEmployeeShiftObject(userUid, shiftDetails);
              }

              if (index === shiftDetails.length - 1) {
                let isPrevAndCurrConsecutiveDay: boolean = true;
                let isPrevAndCurrShiftSameDate: boolean = true;
                if (previousShiftDetails) {
                  isPrevAndCurrShiftSameDate = previousShiftDetails[2].isSame(shiftDetail[1], 'date');
                  isPrevAndCurrConsecutiveDay = previousShiftDetails[2].clone().add(1, 'day').isSame(shiftDetail[1], 'date');
                }
                if (shiftDetails.length === 1 || (!isPrevAndCurrConsecutiveDay && !isPrevAndCurrShiftSameDate)) {
                  const isShiftOnStartOfTheDay = shiftDetail[1].isSame(shiftDetail[1].startOf('day'));
                  this.nonWorkingStartTime = isShiftOnStartOfTheDay ? null : this.getStartEndOf(shiftDetail[1], 'startOf', 'day');
                  this.nonWorkingEndTime = shiftDetail[1].clone();
                  this.setEmployeeShiftObject(userUid, shiftDetails);
                }

                this.nonWorkingStartTime = shiftDetail[2].clone();
                const isShiftOnEndOfTheDay = shiftDetail[2].isSame(shiftDetail[2].endOf('day'));
                this.nonWorkingEndTime = isShiftOnEndOfTheDay ? null : this.getStartEndOf(shiftDetail[2], 'endOf', 'day');
                this.setEmployeeShiftObject(userUid, shiftDetails);
              }
              previousShiftDetails = shiftDetail;
            });
          }
        });
      }
      this.injectEmployeeShift(schedulerInstance, this.nonWorkingHours);
    }
  }

  getStartEndOf(dateTime: Dayjs, type: 'startOf' | 'endOf', unit: dayjs.OpUnitType): Dayjs {
    return type === 'startOf' ? dayjs.tz(dateTime.clone().startOf(unit).format('YYYY-MM-DD HH:mm'), this.selectedTimezone[this.activeDispatchTab]).tz(this.userPreferredTimezone) :
      dayjs.tz(dateTime.clone().endOf(unit).format('YYYY-MM-DD HH:mm'), this.selectedTimezone[this.activeDispatchTab]).tz(this.userPreferredTimezone);
  }

  setEmployeeShiftObject(userUid: string, customShiftDetails: any): void {
    if (this.nonWorkingStartTime && this.nonWorkingEndTime) {
      const nonWorkingHour: any = {
        userUid: userUid,
        startTime: this.nonWorkingStartTime,
        endTime: this.nonWorkingEndTime,
        customShiftDetails: customShiftDetails
      };
      this.nonWorkingHours.push(nonWorkingHour);
      this.nonWorkingStartTime = null;
      this.nonWorkingEndTime = null;
    }
  }

  injectEmployeeShift(schedulerInstance: any, nonWorkingHours: any[]): void {
    if (schedulerInstance && !schedulerInstance?.isDestroyed) {
      this.suspendAllSchedulerEvents(schedulerInstance, { resourceTimeRange: true });
      let resourceTimeRanges: any[] = schedulerInstance?.resourceTimeRanges;
      resourceTimeRanges = resourceTimeRanges.filter((resourceTimeRange: any) => !resourceTimeRange.id.startsWith('empShift_'));
      if(schedulerInstance?.resourceTimeRangeStore?.removeAll) {
        schedulerInstance.resourceTimeRangeStore.removeAll();
      }
      let id = resourceTimeRanges.length + 1;
      nonWorkingHours.forEach((nonWorkingHour: any) => {
        const resourceTimeOff: any = {
          id: 'empShift_' + id.toString() + nonWorkingHour.userUid,
          resourceId: nonWorkingHour.userUid,
          startDate: nonWorkingHour.startTime.tz(this.selectedTimezone[this.activeDispatchTab]).format('YYYY-MM-DD HH:mm'),
          endDate: nonWorkingHour.endTime.tz(this.selectedTimezone[this.activeDispatchTab]).format('YYYY-MM-DD HH:mm'),
          customShiftDetails: nonWorkingHour?.customShiftDetails,
          style: 'margin: auto; justify-content: center',
          timeRangeColor: 'red',
          cls: 'gray out-of-shift-hours',
          timeZone: this.selectedTimezone[this.activeDispatchTab]
        };
        resourceTimeRanges.push(resourceTimeOff);
        id += 1;
      });
      resourceTimeRanges.forEach((resourceTimeRange: any) => {
        schedulerInstance.resourceTimeRangeStore.add(resourceTimeRange);
      });
    }
    this.nonWorkingHours = [];
    this.nonWorkingStartTime = null;
    this.nonWorkingEndTime = null;
    this.resumeAllSchedulerEvents(schedulerInstance, { resourceTimeRange: true });
  }

  async buildBusinessHoursTimeRange(action: 'add' | 'remove', schedulerInstance: any, currentView: 'DAY' | 'WEEK' | 'MONTH', metaData: any): Promise<void> {
    if (schedulerInstance && !schedulerInstance?.isDestroyed) {
      this.suspendAllSchedulerEvents(schedulerInstance, { timeRange: true });
      this.removeSchedulerOutOfBusinessTimeRange(schedulerInstance);
      if (action === 'add') {
        if (currentView === 'DAY') {
          const startDateTime = dayjs(schedulerInstance?.startDate).toDate();
          const endDateTime = dayjs(schedulerInstance?.endDate).subtract(1, 'second').toDate();
          const timeRanges = await this.createBusinessHoursList(startDateTime, endDateTime, metaData);
          timeRanges.forEach((timeRange: any) => {
            schedulerInstance.timeRangeStore.add(timeRange);
          });
        }
      }
    }
    this.resumeAllSchedulerEvents(schedulerInstance, { timeRange: true });
  }

  createBusinessHoursList(fromDate: any, toDate: any, metaData: any): Promise<any> {
    const timeRanges: any[] = [];
    const businessStartTime = this.getBusinessHours('start');
    const businessEndTime = this.getBusinessHours('end');
    return new Promise((resolve) => {
      if (!fromDate || !toDate || !metaData) { resolve([]); }
      fromDate = new Date(fromDate);
      toDate = new Date(toDate);
      for (let currentDate: Date = fromDate; currentDate <= toDate; currentDate.setDate(currentDate.getDate() + 1)) {
        const currentDateFormatted: string = `${currentDate.getFullYear().toString().padStart(2, '0')}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;
        const isHolidayAdded = this.holidayObj[currentDateFormatted];
        const businessHoursOnly = metaData?.scheduler.display.business_hours_only;
        if (!isHolidayAdded && !businessHoursOnly) {
          const id = timeRanges?.length || 0;

          // Start of the day to business start time
          const startOfDay = new Date(currentDate.toDateString() + ' 00:00:00');
          const businessStart = new Date(currentDate.toDateString() + ` ${businessStartTime}`);
          timeRanges.push({
            id: `obh_${id + 1}`,
            name: this._utilityService.getLocaleValue('dispatchBoard.scheduler.out_of_business_hours.title', 'Out of Business Hours'),
            startDate: startOfDay.toISOString(),
            endDate: businessStart.toISOString(),
            type: 'obh'
          });

          // Business end time to end of the day
          const businessEnd = new Date(currentDate.toDateString() + ` ${businessEndTime}`);
          const endOfDay = new Date(currentDate.toDateString() + ' 23:59:59');
          timeRanges.push({
            id: `obh_${id + 2}`,
            name: this._utilityService.getLocaleValue('dispatchBoard.scheduler.out_of_business_hours.title', 'Out of Business Hours'),
            startDate: businessEnd.toISOString(),
            endDate: endOfDay.toISOString(),
            type: 'obh'
          });
        }
      }
      resolve(timeRanges);
    });
  }

  removeSchedulerOutOfBusinessTimeRange(schedulerInstance: any): void {
    if (schedulerInstance && !schedulerInstance?.isDestroyed) {
      const obhEvents = schedulerInstance.timeRangeStore.findByField('type', 'obh');
      obhEvents.forEach((obhEvent: any) => {
        schedulerInstance.timeRangeStore.remove(obhEvent.data);
      });
    }
  }

  buildHolidaysTimeRange(selectedTab: 'JOBS' | 'ROUTES' | 'MOVE-JOBS', schedulerInstance: any, holidays: any[]): void {
    let timeRanges: any[] = [];
    if ((!this.isSchedulerHolidayMounted?.[selectedTab] || selectedTab === 'MOVE-JOBS') && schedulerInstance && holidays?.length) {
      this.suspendAllSchedulerEvents(schedulerInstance, { timeRange: true });
      timeRanges = schedulerInstance?.timeRangeStore?.allRecords || [];
      timeRanges = timeRanges.filter((timeRange: any) => !timeRange.id.startsWith('holiday_'));
      holidays.forEach((holiday: any) => {
        const holidayDate: string = moment(holiday.date).format('YYYY-MM-DD');
        timeRanges.push({
          id: `holiday_${holiday?.holiday_uid}`, name: `${this._utilityService.getLocaleValue('dispatchBoard.scheduler.holiday.title', 'Holiday')} : ${holiday.holiday_name}`,
          startDate: `${holidayDate} 00:00:00`, endDate:  `${holidayDate} 23:59:59`, cls: 'scheduler-holiday', type: 'holiday'
        });
      });
      schedulerInstance.timeRangeStore.add(timeRanges);
      this.isSchedulerHolidayMounted[selectedTab] = true;
      this.resumeAllSchedulerEvents(schedulerInstance, { timeRange: true });
    }
  }

  suspendAllSchedulerEvents(schedulerInstance: any, options?: { resource?: boolean; event?: boolean; assignment?: boolean; timeRange?: boolean; resourceTimeRange?: boolean; preset?: boolean; timeAxis?: boolean }): void {
    if (schedulerInstance && !schedulerInstance?.isDestroyed) {
      schedulerInstance.suspendEvents();
      const { resource = false, event = false, assignment = false, timeRange = false, resourceTimeRange = false, preset = false, timeAxis = false } = options || {};
      if (resource) {
        schedulerInstance.resourceStore.beginBatch();
      }
      if (event) {
        schedulerInstance.eventStore.beginBatch();
      }
      if (assignment) {
        schedulerInstance.assignmentStore.beginBatch();
      }
      if (timeRange) {
        schedulerInstance.timeRangeStore.beginBatch();
      }
      if (resourceTimeRange) {
        schedulerInstance.resourceTimeRangeStore.beginBatch();
      }
      if (preset) {
        schedulerInstance.presets.beginBatch();
      }
      if (timeAxis) {
        schedulerInstance.timeAxis.suspendEvents();
      }
    }
  }

  resumeAllSchedulerEvents(schedulerInstance: any, options?: { resource?: boolean; event?: boolean; assignment?: boolean; timeRange?: boolean; resourceTimeRange?: boolean; preset?: boolean; timeAxis?: boolean }): void {
    if (schedulerInstance && !schedulerInstance?.isDestroyed) {
      const { resource = false, event = false, assignment = false, timeRange = false, resourceTimeRange = false, preset = false, timeAxis = false } = options || {};
      if (resource) {
        schedulerInstance.resourceStore.endBatch();
      }
      if (event) {
        schedulerInstance.eventStore.endBatch();
      }
      if (assignment) {
        schedulerInstance.assignmentStore.endBatch();
      }
      if (timeRange) {
        schedulerInstance.timeRangeStore.endBatch();
      }
      if (resourceTimeRange) {
        schedulerInstance.resourceTimeRangeStore.endBatch();
        schedulerInstance.resourceTimeRangeStore.refreshData();
      }
      if (preset) {
        schedulerInstance.presets.endBatch();
      }
      if (timeAxis) {
        schedulerInstance.timeAxis.resumeEvents();
        schedulerInstance.timeAxis.refreshData();
      }
      schedulerInstance.resumeEvents();
    }
  }

  highlightEventInScheduler(schedulerInstance: any, type: 'event' | 'resource' | 'both', eventRecord: any): void {
    if (!schedulerInstance || !eventRecord) return;

    // This is to avoid the issue of the event element not being found
    setTimeout(() => {
      let eventElement: any;
      if (type === 'event' || type === 'both') {
        eventElement = type === 'both' ? schedulerInstance.getElementFromAssignmentRecord(eventRecord) : schedulerInstance.getElementFromEventRecord(eventRecord);
        if (eventElement?.parentElement) {
          eventElement.parentElement.classList.add('b-fx-highlight');
          setTimeout(() => eventElement.parentElement.classList.remove('b-fx-highlight'), 3000);
        }
      } else if (type === 'resource') {
        schedulerInstance.scrollResourceIntoView(eventRecord, { highlight: true });
      }
    }, 500);
  }

  getSchedulerPresets(): any {
    const presets = {
      'month': [
        {
          id: 'dayAndWeek',
          base: 'dayAndWeek',
          tickWidth: 200,
          headers: [
            {
              unit: 'month',
              dateFormat: 'MMM YYYY',
              align: 'start'
            },
            {
              unit: 'week',
              renderer: (date: any): string => 'Week ' + moment(date).week()
            },
            {
              unit: 'day',
              renderer: (date: any): string => this.schedulerDateRenderer(date, `${this.dateFormat} (ddd)`)
            }
          ]
        },
        {
          id: 'hourAndDay',
          base: 'hourAndDay',
          tickWidth: 120,
          headers: [
            {
              unit: 'day',
              renderer: (date: any): string => this.schedulerDateRenderer(date, 'ddd ' + this.dateFormat)
            },
            {
              unit: 'hour',
              dateFormat: this.timeFormat
            }
          ]
        }
      ],

      'week': [{
        id: 'dayAndWeek',
        base: 'dayAndWeek',
        tickWidth: 200,
        headers: [
          {
            unit: 'week',
            renderer: (date: any): string => 'Week ' + moment(date).week()
          },
          {
            unit: 'day',
            renderer: (date: any): string => this.schedulerDateRenderer(date, `${this.dateFormat} (ddd)`)
          }
        ]
      },
      {
        base: 'minuteAndHour',
        id: 'minuteAndHour',
        tickWidth: 120,
        headers: [
          {
            unit: 'hour',
            dateFormat: this.dateFormat + ' ' + this.timeFormat
          },
          {
            unit: 'minutes',
            dateFormat: 'mm',
            increment: 30
          }
        ]
      },
      {
        id: 'hourAndDay',
        base: 'hourAndDay',
        tickWidth: 120,
        headers: [
          {
            unit: 'day',
            renderer: (date: any): string => this.schedulerDateRenderer(date, 'ddd ' + this.dateFormat)
          },
          {
            unit: 'hour',
            dateFormat: this.timeFormat
          }
        ]
      }
      ],

      'day': [
        {
          id: 'hourAndDay6hr',
          base: 'hourAndDay',
          tickWidth: 120,
          headers: [
            {
              unit: 'day',
              renderer: (date: any): string => this.schedulerDateRenderer(date, 'ddd ' + this.dateFormat)
            },
            {
              unit: 'hour',
              dateFormat: this.timeFormat,
              increment: 6
            }
          ]
        },
        {
          id: 'hourAndDay3hr',
          base: 'hourAndDay',
          tickWidth: 120,
          headers: [
            {
              unit: 'day',
              renderer: (date: any): string => this.schedulerDateRenderer(date, 'ddd ' + this.dateFormat)
            },
            {
              unit: 'hour',
              dateFormat: this.timeFormat,
              increment: 3
            }
          ]
        },

        {
          id: 'customHourAndDay',
          tickWidth: 120,
          headers: [
            {
              unit: 'day',
              renderer: (date: any): string => this.schedulerDateRenderer(date, 'ddd ' + this.dateFormat)
            },
            {
              unit: 'hour',
              dateFormat: this.timeFormat
            }
          ],
          timeResolution: {
            unit: 'minute',
            increment: 30
          },
          defaultSpan: 24,
          shiftUnit: 'day',
          shiftIncrement: 1
        },
        {
          id: 'customMinuteAndHour',
          tickWidth: 120,
          headers: [
            {
              unit: 'day',
              renderer: (date: any): string => this.schedulerDateRenderer(date, 'ddd ' + this.dateFormat)
            },
            {
              unit: 'hour',
              dateFormat: this.timeFormat
            },
            {
              unit: 'minute',
              dateFormat: 'mm',
              increment: 30
            }
          ],
          timeResolution: {
            unit: 'minute',
            increment: 15
          },
          defaultSpan: 24,
          shiftUnit: 'day',
          shiftIncrement: 1
        }
      ]
    };
    return presets;
  }
  scrollToBusinessStart(date: string): any {
    const businessStartTime = this.getBusinessHours('start');
    const businessStartDateTime = new Date(`${date} ${businessStartTime}`);
    return businessStartDateTime;
  }

  getSchedulerScrollDate(schedulerInstance: any, currentView: 'DAY' | 'WEEK' | 'MONTH'): any {
    if (!schedulerInstance) { return; }
    const schedulerStartDate: string = dayjs(schedulerInstance?.startDate).format('YYYY-MM-DD');
    const scrollOption = {
      animate: {
        easing: 'easeFromTo',
        duration: 500
      },
      block: 'start'
    };

    const currentDate = dayjs();
    if (currentView === 'DAY') {
      const isSameDate = currentDate.isSame(dayjs(schedulerStartDate), 'date');
      if (isSameDate) {
        if (currentDate.toDate() >= schedulerInstance.startDate && currentDate.toDate() <= schedulerInstance.endDate) {
          scrollOption.block = 'center';
          const currentdateWithTz = moment().tz(this.selectedTimezone[this.activeDispatchTab]).format('YYYY-MM-DD HH:mm:ss');
          requestAnimationFrame(() => schedulerInstance.scrollToDate(new Date(currentdateWithTz), scrollOption));
          return null;
        } else {
          return this.scrollToBusinessStart(schedulerStartDate);
        }
      } else {
        return this.scrollToBusinessStart(schedulerStartDate);
      }
    } else {
      schedulerInstance.scrollTo(1);
      return null;
    }
  }

  setSchedulerScrollPosition(schedulerInstance: any, currentView: 'DAY' | 'WEEK' | 'MONTH', animate: boolean = true, scrollToDate?: any): void {
    if (!schedulerInstance) { return; }
    if (scrollToDate) {
      const schedulerStartDate = new Date(schedulerInstance.startDate);
      const schedulerEndDate = new Date(schedulerInstance.endDate);
      if (!(scrollToDate >= schedulerStartDate && scrollToDate <= schedulerEndDate)) {
        scrollToDate = this.getSchedulerScrollDate(schedulerInstance, currentView);
      }
    } else {
      scrollToDate = this.getSchedulerScrollDate(schedulerInstance, currentView);
    }    
    if (scrollToDate) {
      const scrollOption = {
        block: 'center'
      };
      if (animate) {
        scrollOption['animate'] = {
          easing: 'easeFromTo',
          duration: 500
        };
      }
      requestAnimationFrame(() => schedulerInstance.scrollToDate(scrollToDate, scrollOption));
    }
  }

  schedulerDateRenderer(date: any, format: any): string {
    const tickDate = dayjs(date);
    const [isHoliday, holidayName] = this.isConflictWithHolidays(tickDate.clone().startOf('d').toISOString(), tickDate.clone().endOf('d').toISOString());
    const rendererHtml = `<div class='flex items-center' ${isHoliday ? `title='${tickDate.format(format)}: ${this._utilityService.getLocaleValue('dispatchBoard.scheduler.holiday.title', 'Holiday')} - ${holidayName}'` : ''}> <span class='b-sch-header-text'>${tickDate.format(format)}</span></div>`;
    return rendererHtml;
  }

  isJobScheduledWithInRouteDuration(routeDetails: any, jobDetails: any): boolean {
    if (!jobDetails?.scheduled_start_time || !jobDetails?.scheduled_end_time || !routeDetails?.departure) { return false; }
    const routeDuration = routeDetails?.duration || 1;
    const routeStartDateTime = moment.utc(routeDetails?.departure);
    const routeEndDateTime = routeStartDateTime.clone().add(routeDuration, 'h');
    const jobScheduledStartDateTime = moment.utc(jobDetails?.scheduled_start_time);
    const jobScheduledEndDateTime = moment.utc(jobDetails?.scheduled_end_time);
    let canFit: boolean = false;
    if (jobScheduledStartDateTime.isBetween(routeStartDateTime, routeEndDateTime, null, '[]') && jobScheduledEndDateTime.isBetween(routeStartDateTime, routeEndDateTime, null, '[]')) {
      canFit = true;
    }
    return canFit;
  }

  getRoutesCount(date: any, teamUid: string): void {
    const filter = {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'from_date': date.startOf('month').format('YYYY-MM-DD'), 'to_date': date.endOf('month').format('YYYY-MM-DD'), 'filter.team_uid': teamUid
    };
    this._dataCollectorService.getData(this._mapService.mapsAPi.getRoutesCount, filter)
      .subscribe((res: any) => {
        const allRouteCount = res?.data || [];
        const calendarDates = document.querySelectorAll('.mat-calendar-body-cell-content');
        allRouteCount.forEach((route: any, i: number) => {
          if (route?.job_routes > 0) {
            calendarDates[i].classList.add('route-available');
          } else {
            calendarDates[i].classList.remove('route-available');
          }
        });
      });
  }


  //Use only for route tab
  getNearByData(metaData: any, mapPanData?: MapPanData): Observable<any> {
    metaData = _.cloneDeep(metaData);
    this.cancelNearByDataRequest$.next();
    mapPanData = mapPanData ? mapPanData : this.lastMapPanData ? this.lastMapPanData : { geo_cords: this._mapService.initalMapCurrentLocation, radius: this._mapService.getDynamicRadius(11) };
    if (!mapPanData || !mapPanData.geo_cords || !metaData || mapPanData?.geo_cords?.length !== 2) {
      return of({});
    }
    this.lastMapPanData = mapPanData;
    const layers = metaData?.map?.layers;
    if (!metaData?.map?.nearby_jobs) {
      layers['jobs'] = false;
    }
    layers['users'] = false; //set user layer to false by default as we are not showing users from nearby data
    let enabledLayers = Object.keys(layers)?.filter((layerName: any) => layers[layerName]).map((layer: any) => this.mapLayersRef[layer]);
    enabledLayers = _.compact(enabledLayers);
    if (enabledLayers.length === 0) {
      return of({});
    }
    const isMultiModules = enabledLayers.length > 1;
    const nearbyParam = {
      'module_name': enabledLayers.join(','),
      'multiple_modules': isMultiModules,
      'location': mapPanData.geo_cords.toString(),
      'radius': mapPanData?.radius || this._mapService.getDynamicRadius(11),
      'count': 500,
      'use_color_profile': true
    };
    if (metaData?.map?.layers?.routes) {
      nearbyParam['filter.has_route'] = false;
    } else {
      delete nearbyParam['filter.has_route'];
    }
    this._mapService.isNearByLoading.set(true);
    this.currentNearbyRequest$ = this._dataCollectorService.getData(this.getNearByUrl(), nearbyParam).pipe(
      takeUntil(this.cancelNearByDataRequest$),
      catchError(() => of({})),
      finalize(() => {
        this.currentNearbyRequest$ = null;
        this._mapService.isNearByLoading.set(false);
      }),
      share()
    );
    return this.currentNearbyRequest$;
  }

  fetchNearByData(metaData: any, param: any): Observable<any> {
    if (!metaData || !param) {
      return of({});
    }
    this.cancelNearByDataRequest$.next();
    const layers = metaData?.map?.layers;
    if (!layers) {
      return of({});
    }
    let enabledLayers = Object.keys(layers)
      .filter((layerName: any) => layers[layerName])
      .map((layer: any) => this.mapLayersRef[layer])
      .filter(Boolean);
    if (enabledLayers.includes('USER') && !param?.team_uid) {
      return of({});
    }
    if (enabledLayers.length === 0) {
      return of({});
    }
    this._mapService.isNearByLoading.set(true);
    const nearbyParam: any = {
      ...param,
      'module_name': enabledLayers.join(','),
      'multiple_modules': enabledLayers.length > 1,
      'count': 500,
      'use_color_profile': true
    };
    if (metaData?.map?.layers?.routes) {
      nearbyParam['filter.has_route'] = false;
    }
    if (enabledLayers.includes('USER')) {
      nearbyParam['filter.team_uid'] = param.team_uid;
    }
    delete nearbyParam['team_uid'];
    return this._dataCollectorService.getData(this.getNearByUrl(), nearbyParam).pipe(
      debounceTime(500),
      takeUntil(this.cancelNearByDataRequest$),
      catchError(() => of({})),
      finalize(() => this._mapService.isNearByLoading.set(false)),
      share()
    );
  }

  resetNearByData(): void {
    setTimeout(() => {
      this._mapService.propertyLocationData.next([]);
      this._mapService.customerLocationData.next([]);
      this._mapService.assetLocationData.next([]);
      this._mapService.employeeLocationData.next([]);
    });
  }

  async refreshNearByMapDataWithoutPan(metaData: any, selectedDispatchTab: 'JOBS' | 'ROUTES'): Promise<any> {
    const nearByData: any = await this.getNearByData(metaData, this.lastMapPanData);
    this.injectNearByMapData(metaData, nearByData, selectedDispatchTab);
  }

  injectNearByMapData(metaData: any, nearByData: any, selectedDispatchTab: 'JOBS' | 'ROUTES'): void {
    const layers = metaData?.map?.layers;
    const enabledLayers = Object.keys(layers)?.filter((layerName: any) => layers[layerName]).map((layer: any) => this.mapLayersRef[layer]);
    if (enabledLayers.includes('JOB')) {
      const nearByJobs = nearByData?.data?.jobs || [];
      const populateOnlyNearByData = selectedDispatchTab === 'JOBS'; //Populate all (grid + scheduler + nearby) data for route tab
      this.injectJobLocationMapData(selectedDispatchTab, 'nearByJob', metaData, nearByJobs, false, !nearByData, true, populateOnlyNearByData);
    }
    else {
      this.injectJobLocationMapData(selectedDispatchTab, 'nearByJob', metaData, [], false, false, true, true);
    }
    if (enabledLayers.includes('USER')) {
      const nearByUsers = nearByData?.data?.users || [];
      this.employeeLocationData[selectedDispatchTab] = nearByUsers;
      this.injectEmployeeLocationMapData(selectedDispatchTab, metaData);
    }
    else {
      this.employeeLocationData[selectedDispatchTab] = [];
      this.injectEmployeeLocationMapData(selectedDispatchTab, metaData);
    }
    if (enabledLayers.includes('PROPERTY')) {
      setTimeout(()=>{this._mapService.propertyLocationData.next(nearByData?.data?.properties || []);});
    }
    else {
      this._mapService.propertyLocationData.next([]);
    }
    if (enabledLayers.includes('CUSTOMER')) {
      setTimeout(()=>{this._mapService.customerLocationData.next(nearByData?.data?.customers || []);});
    }
    else {
      this._mapService.customerLocationData.next([]);
    }
    if (enabledLayers.includes('ASSETS')) {
      setTimeout(()=>{this._mapService.assetLocationData.next(nearByData?.data?.assets || []);});
    }
    else {
      this._mapService.assetLocationData.next([]);
    }
  }

  resetNearByMapData(selectedDispatchTab: 'JOBS' | 'ROUTES', metaData: any): void {
    this.resetNearByData();
    if (selectedDispatchTab === 'JOBS') {
      this.jobLocationMapData[selectedDispatchTab].nearByJob = [];
    }
    this.injectJobLocationMapData(selectedDispatchTab, null, metaData, null, false, true);
  }

  injectJobLocationMapData(selectedDispatchTab: 'JOBS' | 'ROUTES' | null, source: 'gridJob' | 'schedulerJob' | 'nearByJob' | null, metaData: any, data: any, resetNearByData: boolean = false, populateAvailableData: boolean = false, useColorProfile: boolean = true, onlyNearByData: boolean = false): any {
    if (resetNearByData) {
      this.resetNearByData();
      return;
    }
    if (!populateAvailableData) {
      if (selectedDispatchTab === 'ROUTES' && source === 'schedulerJob') {
        this.jobLocationMapData[selectedDispatchTab][source] = [];
      }
      else {
        selectedDispatchTab = source === 'nearByJob' ? this.activeDispatchTab : selectedDispatchTab;
        if (Array.isArray(data)) {
          data = data.map((job: any) => ({
            ...job,
            source: source
          }))
        }
        this.jobLocationMapData[selectedDispatchTab][source] = data;
      }
    }
    if (metaData && (selectedDispatchTab === this.activeDispatchTab || source === 'nearByJob')) {
      const layers = metaData?.map?.layers;
      const enabledLayers = Object.keys(layers)?.filter((layerName: any) => layers[layerName]).map((layer: any) => this.mapLayersRef[layer]);
      if (enabledLayers.includes('JOB') && (metaData?.map?.enable_map_view)) {
        let mapJobs: any[] = [];
        if (onlyNearByData || this._mapService.isNearByEnabled()) {
          mapJobs = this.jobLocationMapData[selectedDispatchTab].nearByJob || [];
        }
        else {
          mapJobs = _.union(...Object.values(this.jobLocationMapData[selectedDispatchTab]));
        }
        mapJobs = _.uniqBy(mapJobs, (job: any) => job?.job_uid);
        this._mapService.jobLocationData.next({ data: mapJobs, useColorProfile: useColorProfile, openTooltip: !!this._mapService.openTooltip.jobUid, jobUid: this._mapService.openTooltip.jobUid });
      }
      else {
        this._mapService.jobLocationData.next([]);
      }
    }
  }

  injectDrawOnMapData(selectedGridTab: 'JOBS' | 'ROUTES', selectedPlanningTab: 'SCHEDULE' | 'MAP', metaData: any, data: any, populateAvailableData: boolean = false): void {
    if (!populateAvailableData) {
      if (!metaData?.map?.layers?.routes) {
        data = data.filter((job: any) => !job?.route);
      }
      this.drawOnMapData[selectedGridTab] = data;
    }
    setTimeout(() => {
      if (metaData?.map?.layers?.jobs) {
        setTimeout(() => { this._mapService.routeJobLocationData.next(this.drawOnMapData.JOBS); });
      }
      else {
        this._mapService.routeJobLocationData.next([]);
      }
      if (metaData?.map?.layers?.routes) {
        setTimeout(() => { this._mapService.allRoutesLocationData.next(this.drawOnMapData.ROUTES); });
      }
      else {
        this._mapService.allRoutesLocationData.next([]);
      }
    }, 500);
  }

  get selectedTeamUid(): string {
    return this.selectedTeam[this.activeDispatchTab];
  }

  get shouldDisplayLiveTechButtonInMap(): boolean {
    return this.showFindLiveTechInJobMapPopup[this.activeDispatchTab] && this.activeDispatchTab === 'JOBS';
  }

  async getServiceTerritory(): Promise<any> {
    return new Promise((resolve, reject) => {
      const params = { count: 200, page: 1, populate_teams: true };
      this._dataCollectorService.getData(this._mapService.mapsAPi.getServiceTerritory, params)
        .subscribe((response: any) => {
          if (response?.data) {
            this.serviceTerritories = response?.data || [];
            resolve(this.serviceTerritories);
          }
          else {
            resolve([]);
          }
        }, (error: any) => {
          resolve([]);
        });
    });
  }

  injectServiceTerritoryMapData(metaData: any): void {
    if (metaData?.map?.enable_map_view && metaData?.map?.layers?.service_territories) {
      this._mapService.serviceTerritoryLocationData.next(this.serviceTerritories);
    }
    else {
      this._mapService.serviceTerritoryLocationData.next([]);
    }
  }

  injectEmployeeLocationMapData(selectedDispatchTab: 'JOBS' | 'ROUTES' , metaData: any): void {
    if (metaData?.map?.enable_map_view && metaData?.map.layers.users) {
      this._mapService.employeeLocationData.next(this.employeeLocationData[selectedDispatchTab]);
    }
    else {
      this._mapService.employeeLocationData.next([]);
    }
  }

  sanitizeFilterOptions(filterOptions: any): any {
    if (filterOptions && _.isObject(filterOptions) && !_.isEmpty(filterOptions)) {
      Object.keys(filterOptions).forEach((key: any) => {
        if (filterOptions[key] && _.isArray(filterOptions[key])) {
          filterOptions[key] = filterOptions[key].map((option: any) => this._utilityService.setPrepopulatedDateValue(option));
        }
      });
    }
    return filterOptions;
  }

  getSelectedTeamFromEmployeeFilter(filterRules: any[]): string {
    let teamUid: string = null;
    if (filterRules?.length) {
      filterRules.forEach((rule: any) => {
        if (rule?.key === 'assigned_to.user_uid' && rule?.filterKey?.['filter.team_uid']) {
          teamUid = rule?.filterKey?.['filter.team_uid']
        }
      });
    }
    return teamUid;
  }

  getTimeDiff(startDateTime: Moment | string, endDateTime: Moment | string, durationUnit: moment.unitOfTime.Diff, decimal: number = 2): any {
    if (typeof startDateTime === 'string' ) {
      startDateTime = moment(startDateTime);
    }
    if (typeof endDateTime === 'string' ) {
      endDateTime = moment(endDateTime);
    }
    if (startDateTime.isAfter(endDateTime)) {
      [startDateTime, endDateTime] = [endDateTime, startDateTime];
    }
    return endDateTime.diff(startDateTime, durationUnit, true).toFixed(decimal);
  }

  createNewTeam(): void {
    this.router.navigateByUrl('/settings?page=NEW_TEAM');
  }

  isMapLayerChanged(oldMetaData: any, newMetaData: any): [boolean, { [key: string]: boolean }] {
    const oldLayers = oldMetaData?.map?.layers || {};
    const newLayers = newMetaData?.map?.layers || {};
    const changedLayers = Object.keys(newLayers).reduce((acc, layer) => {
      if (oldLayers[layer] !== newLayers[layer]) {
        acc[layer] = true;
      }
      return acc;
    }, {} as { [key: string]: boolean });
    if (oldMetaData?.map?.nearby_jobs !== newMetaData?.map?.nearby_jobs) {
      changedLayers['nearby_jobs'] = true;
    }
    const isLayerChanged = Object.keys(changedLayers).length > 0;
    return [isLayerChanged, changedLayers];
  }

  isJobHasGeoCords(jobDetails: any): boolean {
    return jobDetails?.customer_address?.geo_cordinates && this._utilityService.isValidGeoCords(jobDetails?.customer_address?.geo_cordinates);
  }

  createQueryParam(selectedTab: 'ROUTES' | 'TRACKING' | 'PLANNING' | 'SCHEDULE' | 'MAP', additionalParams?: any): string {
    const queryParams = { tab: selectedTab };
    if (additionalParams) {
      Object.keys(additionalParams).forEach((key: any) => {
        if (additionalParams[key]) {
          queryParams[key] = additionalParams[key];
        }
      });
    }
    const tree = this.router.createUrlTree(['/dispatch_board'], { queryParams: queryParams });
    return this.serializer.serialize(tree);
  }

  getLocalMetaData(): any {
    const localMetadata = this._localStorageService.getLocalStorage('dispatch_board_metadata');
    return this.metaFeatureGuard(localMetadata);
  }

  metaFeatureGuard(metaData: any): any {
    if (!metaData || !Object.keys(metaData).length) { return metaData; };
    if (!this.moduleAccess.map && metaData?.map) {
      metaData.map.enable_map_view = false;
    }
    if(!this._utilityService.companyPolicy.dispatch_board.distance_time && metaData?.scheduler) {
      metaData.scheduler.display.duration_between_jobs = false;
    }
    if ((metaData?.grid?.table_view || [])?.length > this.tableViewAttributeMaxCount) {
      metaData.grid.table_view = (metaData?.grid?.table_view || []).slice(0, this.tableViewAttributeMaxCount);
    }
    return metaData;
  }

  async sanitizeTemplateMetaData(metaData: any): Promise<any> {
    return new Promise(async (resolve: any) => {
      if (metaData) {
        await this.sharedService.getJobAttributes();
        await this.sharedService.getRouteAttributes();
        if (metaData?.grid?.card_view) {
          metaData.grid.card_view = this.addDisplayKeySelectedAttributes(metaData.grid.card_view, this.sharedService.allJobAttributes);
        }
        if (metaData?.grid?.route_card_view) {
          metaData.grid.route_card_view = this.addDisplayKeySelectedAttributes(metaData.grid.route_card_view, this.sharedService.allRouteAttributes);
        }
        if (metaData?.grid?.table_view) {
          metaData.grid.table_view = this.addDisplayKeySelectedAttributes(metaData.grid.table_view, this.sharedService.allJobAttributes);
        }
        if (metaData?.grid?.route_table_view) {
          metaData.grid.route_table_view = this.addDisplayKeySelectedAttributes(metaData.grid.route_table_view, this.sharedService.allRouteAttributes);
        }
        if (metaData?.employee?.card_view) {
          metaData.employee.card_view = this.addDisplayKeySelectedAttributes(metaData.employee.card_view, this.sharedService.allEmployeeAttributes);
        }
        if (metaData?.scheduler?.card_view) {
          metaData.scheduler.card_view = this.addDisplayKeySelectedAttributes(metaData.scheduler.card_view, this.sharedService.allJobAttributes);
        }
      }
      resolve(metaData);
    });
  }

  getDisplayKey(attribute: any, attributeList: any[]): string {
    if (attribute?.label && attribute?.selector && attributeList?.length) {
      if (attribute?.displayKey) {
        return attribute?.displayKey;
      }
      const baseAttribute = _.find(attributeList, { label: attribute.label, selector: attribute.selector });
      if (baseAttribute && baseAttribute?.displayKey) {
        return baseAttribute?.displayKey;
      }
      return null;
    }
  }

  addDisplayKeySelectedAttributes(selectedAttributes: any, allAttributes: any): any {
    if (Array.isArray(selectedAttributes)) {
      selectedAttributes = selectedAttributes?.map((attribute: any) => this.setDisplayKeyAndValue(attribute, allAttributes));
      return selectedAttributes;
    }
    else if(selectedAttributes && typeof selectedAttributes === 'object') {
      const filteredList = {};
      let newRowIndex = 1;
      Object.keys(selectedAttributes).map(key => Number(key)).forEach((rowNumber) => {
        filteredList[newRowIndex] = [];
        selectedAttributes[rowNumber].forEach((attribute: any, columnIndex: number) => {
          if (_.some(allAttributes, { key: attribute.key })) {
            attribute.column = columnIndex + 1;
            attribute.row = newRowIndex;
            attribute = this.setDisplayKeyAndValue(attribute, allAttributes);
            filteredList[newRowIndex].push(attribute);
          }
        });
        if (filteredList[newRowIndex].length === 0) {
          delete filteredList[newRowIndex];
        }
        else {
          newRowIndex ++;
        }
      });
      return filteredList;
    }
  }

  setDisplayKeyAndValue(attribute: any, allAttributes: any[]): void {
    if (!attribute || !allAttributes) { return attribute; }
    if (attribute?.label && !attribute?.isDefaultField) {
      attribute['displayKeyValue'] = attribute.label;
    }
    else {
      attribute['displayKey'] = this.getDisplayKey(attribute, allAttributes);
      attribute['displayKeyValue'] = this._utilityService.getLocaleValue(attribute.displayKey) || attribute?.label;
      if (!attribute['displayKeyValue']) {
        attribute['displayKeyValue'] = attribute?.label;
      }
    }
    return attribute;
  }

  getJobGeoCords(jobDetails: any): any[] {
    let hasGeoCords = false;
    let geoCords = [];
    if(this.isJobHasGeoCords(jobDetails)) {
      const _geoCords = jobDetails?.customer_address?.geo_cordinates;
      if(_geoCords.length === 2 && typeof _geoCords[0] === 'number' &&  typeof _geoCords[1] === 'number' && _geoCords[0] && _geoCords[1]) {
        geoCords = _geoCords;
        hasGeoCords = true;
      }
    }
    return [hasGeoCords, geoCords];
  }

  getJobDetails(jobUid: string): Observable<any> {
    if(!jobUid) {
      return of(null);
    }
    const jobUrl = `${this.jobDetailsUrl}/${jobUid}`;
    return this._dataCollectorService.getData(jobUrl);
  }

  checkNonJobEventAccess(nonJobEventDetails: any): { view: boolean; edit: boolean; delete: boolean } {
    const accessControl = { view: false, edit: false, delete: false };
    const currentUser = this._utilityService.user;
    const role: string = currentUser?.role?.role_key || '';
    const userUid: string = currentUser?.user_uid ||'';
    if (role === 'ADMIN') {
      accessControl.view = true;
      accessControl.edit = true;
      accessControl.delete = true;
      return accessControl;
    }
    else {
      const isAssignedtoCurrentUser: boolean = nonJobEventDetails?.assigned_to?.filter((assignedTo: any) => assignedTo?.user?.user_uid === userUid)?.length;
      const isCreatedByCurrentUser: boolean = nonJobEventDetails?.created_by?.user_uid === userUid;
      if (role === 'TEAM_LEADER') {
        if (isAssignedtoCurrentUser || isCreatedByCurrentUser) {
          accessControl.view = true;
          accessControl.edit = true;
          accessControl.delete = true;
        }
      }
      else if (role === 'FIELD_EXECUTIVE') {
        if (isCreatedByCurrentUser || isAssignedtoCurrentUser) {
          accessControl.view = true;
        }
        if (isCreatedByCurrentUser) {
          accessControl.edit = true;
          accessControl.delete = true;
        }
      }
      return accessControl;
    }
  }

  

  buildJobDistancePayload(resourceList: any[], eventList: any[], modeOfTransport: string, specificUsers?: string[]): any {
    const payload: any[] = [];
    const userJobs = {};
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const modeOfTransportRef = {'CAR': 'car', 'TRUCK': 'car', 'BIKE': 'bike', 'WALK': 'foot' }; //['car', 'bike', 'foot'] vehicle types supported by grasshopper  API
    let schedulerResource: any;
    if(specificUsers && specificUsers.length) {
      schedulerResource = resourceList.map((resource: any) => resource.user_uid).filter((userUid: any) => specificUsers.includes(userUid));
    }
    else {
      schedulerResource = resourceList.map((resource: any) => resource.user_uid);
    }
    _.forEach(eventList, (event: any) => {
      const assignedTo: any[] = event?.assigned_to || [];
      const scheduledStartTime = event?.scheduled_start_time;
      const [hasGeoCords, geoCords] = this.getJobGeoCords(event);
      if (hasGeoCords && scheduledStartTime) {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const customJobDetails = { job_uid: event.job_uid, lat: geoCords[0], lng: geoCords[1], scheduledStartTime: dayjs(scheduledStartTime) };
        if (assignedTo.length) {
          _.forEach(assignedTo, (assignee: any) => {
            const userUid = assignee.user.user_uid;
            if (schedulerResource.includes(userUid)) {
              if (!userJobs.hasOwnProperty(userUid)) {
                userJobs[userUid] = [];
              }
              userJobs[userUid].push(customJobDetails);
            }
          });
        }
      }
    });

    _.forEach(Object.keys(userJobs), (userUid: string) => {
      if(userJobs[userUid].length > 1) {
        userJobs[userUid] = userJobs[userUid].sort((one: any, two: any) => one.scheduledStartTime.diff(two.scheduledStartTime));
        userJobs[userUid] = userJobs[userUid].map((userJob: any) => _.omit(userJob, 'scheduledStartTime'));
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const customPayload = { user_uid: userUid, jobs: userJobs[userUid], vehicle: modeOfTransportRef[modeOfTransport]};
        payload.push(customPayload);
      }
    });
    return { 'routes': payload };
  }

  async getDistanceBetweenJobs(resourceList: any[], eventList: any[], modeOfTransport: string, specificUsers?: string[]): Promise<any> {
    const distanceBetweenJobsUrl = `${this._dataCollectorService.baseurl()}/location/dispatch_board/routing`;
    const payload = this.buildJobDistancePayload(resourceList, eventList, modeOfTransport, specificUsers);
    return new Promise((resolve, reject) => {
      this._dataCollectorService.postData(distanceBetweenJobsUrl, payload)
        .subscribe((response: any) => {
          resolve(response?.data || []);
        },
        (error: any) => {
          resolve([]);
        });
    });
  }

  getTimezonePrecedence(teamTimezone: string): string {
    let timezone = this.userPreferredTimezone;
    if (this.companyConfig?.multipleTimezone) {
      if (teamTimezone) {
        this.customTimezone = teamTimezone;
        timezone = teamTimezone;
      }
      else if (this.customTimezone) {
        timezone = this.customTimezone;
      }
      else {
        timezone = this.userPreferredTimezone;
      }
    }
    else {
      if (teamTimezone) {
        this.customTimezone = teamTimezone;
        timezone = teamTimezone;
      }
      else {
        timezone = this.userPreferredTimezone;
      }
    }
    return timezone;
  }

  getJobTitle(prefix: string, eventNumber: string, eventTitle: string): string {
    return `#${prefix || ''}${eventNumber || ''} ${eventTitle || ''}`;
  }

  removeRouteCardDefaultAttributes(routeGridCard: any): any {
    const defaultRouteGridCardSelectors = ['route_name', 'duration', 'total_jobs'];
    const updatedRouteGridcard = {};
    let rowIndex: number = 0;
    const routeCardRows: any = Object.keys(routeGridCard);
    routeCardRows.forEach((row: any) => {
       const rowContent = routeGridCard[row].filter((column: any) => !defaultRouteGridCardSelectors.includes(column?.selector));
      if (rowContent?.length) {
        updatedRouteGridcard[rowIndex] = rowContent;
        rowIndex ++;
      }
    });
    return updatedRouteGridcard;
  }

  getMessageWithNote(jobDetails: any): string {
    const baseMessage = this._utilityService.getLocaleValue('dispatchBoard.scheduler.dialog.clear_schedule.message');
    if (jobDetails?.route) {
      return `${baseMessage} ?<br><p class="font-medium text-base mt-2 text-red-600">${this._utilityService.getLocaleValue('dispatchBoard.scheduler.dialog.clear_schedule.note')} ' ${jobDetails?.route?.route_name} '</p>`;
    }
    return `${baseMessage} ?`;
  }

  //Mixpanel event tracking
  trackNavigationEvent(module: string, skipPrefix: boolean = false): void {
    let eventName: string = '';
    if(!skipPrefix) {
      eventName += 'DISPATCH_BOARD_';
    }
    eventName += module.toUpperCase();
    this.analyticsService.trackEvent(eventName);
  }

  trackEvent(event: string | string[], skipTabName: boolean = false ): void {
    if (event) {
      let eventName: string = 'dispatch_board_';
      if (typeof event === 'string') {
        if (!skipTabName) {
          eventName += `${this.currentTab.toLowerCase()}_`;
        }
        eventName += event.toLowerCase();
        this.analyticsService.trackEvent(eventName);
      }
      else if (typeof event === 'object' && event?.length) {
        event.forEach((_event: any) => {
          eventName = 'dispatch_board_';
          if (!skipTabName) {
            eventName += `${this.currentTab.toLowerCase()}_`;
          }
          eventName += _event.toLowerCase();
          this.analyticsService.trackEvent(eventName);
        });
      }
    }
  }

  trackMixPanelEvent(event: string | string[]): void {
    if (event) {
      if (typeof event === 'string') {
        this.analyticsService.trackEvent(event);
      }
      else if (typeof event === 'object' && event?.length) {
        event.forEach((eventName: any) => {
          this.analyticsService.trackEvent(eventName);
        });
      }
    }
  }

  //Advanced Filters
  getKeywordSearchFilterRule(keyword: string): any {
    if(!keyword) {
      keyword = '';
    }
    return {
      'displayKeyValue': [keyword.trim()],
      'key': 'keyword',
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'field_type': 'TEXT',
      'value': keyword.trim(),
      'operator': 'CONTAINS',
      'type': 'default_field'
    };
  }

  getServiceTerritoryFilterRule(territoryUids: string[] = [], territoryNames: string[] = [], source: 'dispatch_board_global' | null): any {
    if(territoryUids?.length !== territoryNames?.length) {
      return {};
    }
    return {
      'displayKeyValue': territoryNames || [],
      'key': 'territory_uid',
      'operator': 'CONTAINS',
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'field_type': 'LOOKUP',
      'module': 'JOB',
      'value': territoryUids || [],
      'type': 'nested_field',
      'source': source
    };
  }

  getFilterValue(key: string, filterRules: any[] = []): any {
    if (!key || !filterRules || !filterRules?.length) { return; }
    let value: any;
    _.forEach(filterRules, (filterRule: any) => {
      if (filterRule?.key === key) {
        value = filterRule?.value;
        return false;
      }
    });
    return value;
  }

  getFilterRuleByKey(key: string, filterRules: any[] = []): any {
    if (!key || !filterRules || !filterRules?.length) { return; }
    let rule: any;
    _.forEach(filterRules, (filterRule: any) => {
      if (filterRule?.key === key) {
        rule = filterRule;
        return false;
      }
    });
    return rule;
  }

  removeFilterRuleBySelector(filterRules: any[] = [], selector: any): any {
    if (!selector || !filterRules || !filterRules?.length) { return; }
    const _filterRules = _.cloneDeep(filterRules);
    _.remove(_filterRules, selector);
    return _filterRules;
  }

  removeFilterKey(key: string | string[], filterRules: any[]): any {
    let _filterRules = _.cloneDeep(filterRules);
    if (!key || !_filterRules || !_filterRules?.length) { return _filterRules; }
    _filterRules = _filterRules.filter((filterRule: any) => {
      if(typeof key === 'string') {
        return filterRule.key !== key;
      }
      else if(typeof key === 'object') {
        return !key.includes(filterRule.key);
      }
    });
    return _filterRules;
  }

  removeFilterKeyWithValue(key: string, value: any, filterRules: any[]): any {
    let _filterRules = _.cloneDeep(filterRules);
    if (!key || !_filterRules || !_filterRules?.length) { return _filterRules; }
    _filterRules = _filterRules.filter((filterRule: any) => !(filterRule?.key === key && filterRule?.value === value));
    return _filterRules;
  }

  isSameFilterRule(filterRuleOne: any[], filterRuleTwo: any[]): boolean {
    if (!filterRuleOne || !filterRuleTwo || filterRuleOne.length !== filterRuleTwo.length) return false;

    const filterMap = new Map(filterRuleOne.map(filter => [filter.key, {
      ...filter,
      value: this.normalizeFilterRuleValue(filter.value),
      rangeKey: filter.rangeKey ?? null
    }]));

    for (const filterRule of filterRuleTwo) {
      const normalizedFilterRule = {
        ...filterRule,
        value: this.normalizeFilterRuleValue(filterRule.value),
        rangeKey: filterRule.rangeKey ?? null
      };

      const matchedFilter = filterMap.get(filterRule.key);
      if (!matchedFilter || !_.isEqual(normalizedFilterRule.key, matchedFilter.key) || !_.isEqual(normalizedFilterRule.value, matchedFilter.value)) return false;
    }
    return true;
  }

  normalizeFilterRuleValue(value: any): any {
    if (Array.isArray(value) && value.length === 1) return value[0];
    return value;
  }

  updateFilterRule(filterRules: any[], key: string, value: any, displayKeyValue?: any): any {
    const _filterRules = _.cloneDeep(filterRules);
    if (!key || !_filterRules || !_filterRules?.length) { return _filterRules; }
    if(_.find(filterRules, {'key': key})) {
      _.forEach(_filterRules, (filterRule: any) => {
        if(filterRule.key === key) {
          filterRule.value = value;
          if (displayKeyValue) {
            filterRule['displayKeyValue'] = displayKeyValue;
          }
          return false;
        }
      });
    }
    return _filterRules;
  }

  addSearchKeywordFilterRule(keywoard: string, filterRules: any[]): any[] {
    let _filterRules = _.cloneDeep(filterRules) || [];
    const jobSearchFilterRule = this.getKeywordSearchFilterRule(keywoard);
    _filterRules = this.removeFilterKey('keyword',  _filterRules);
    _filterRules.push(jobSearchFilterRule);
    return _filterRules;
  }

  getUserWorkHours(userUid: string): Promise<any> {
    if(userUid) {
      const workHourUrl = `${this.baseUrl}/user/${userUid}/work_hours`;
      return this._dataCollectorService.getData(workHourUrl).pipe(map((response: any) => response?.data || [])).toPromise();
    }
  }

  getAddressText(address: any): string {
    return _.compact([address?.street, address?.landmark, address?.city || address?.name, address?.state, address?.zipcode || address?.zip_code, address?.country?.label || (_.isString(address?.country) ? address?.country : '')]).join(', ');
  }

  getUserShiftDetails(teamUid: string, startDate: string, endDate: string): Observable<any> {
    const params = { 'filter.team_uid': teamUid, 'filter.start_date_time': startDate, 'filter.end_date_time': endDate, count: 200 };
    return this._dataCollectorService.getData(`${this.baseUrl}/timesheet/user_shifts`, params);
  }
}
